var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("h2", { staticClass: "match-header" }, [
            _vm._v(_vm._s(_vm.community.name))
          ]),
          _vm._v(" "),
          _c(
            "md-card",
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    { attrs: { "md-alignment": "space-between" } },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "community-expand-button m-left-5" },
                            [_vm._v("Site Status")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      _c(
                        "md-card-content",
                        { staticClass: "ptop0 card-content" },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "form-site-status",
                              attrs: {
                                autocomplete: "off",
                                "data-vv-scope": "form-site-status"
                              },
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.submitSiteStatus(
                                    "form-site-status"
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-20"
                                },
                                [
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5" },
                                    [
                                      _c("label", [_vm._v("Matching:")]),
                                      _vm._v(" "),
                                      _c(
                                        "md-select",
                                        {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "Matching",
                                            placeholder: "Matching",
                                            id: "matching"
                                          },
                                          model: {
                                            value: _vm.settings.matching,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.settings,
                                                "matching",
                                                $$v
                                              )
                                            },
                                            expression: "settings.matching"
                                          }
                                        },
                                        [
                                          _c(
                                            "md-option",
                                            { attrs: { value: "" } },
                                            [_vm._v("Please select")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-option",
                                            { attrs: { value: "Manual" } },
                                            [_vm._v("Manual")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-option",
                                            { attrs: { value: "Automated" } },
                                            [_vm._v("Automated")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("form-site-status.Matching")
                                    ? _c(
                                        "p",
                                        { staticClass: "error m-left-5" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "form-site-status.Matching"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-20"
                                },
                                [
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5" },
                                    [
                                      _c("label", [_vm._v("Site Status:")]),
                                      _vm._v(" "),
                                      _c(
                                        "md-select",
                                        {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "Site status",
                                            placeholder: "Site status",
                                            id: "siteStatus"
                                          },
                                          model: {
                                            value: _vm.settings.siteStatus,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.settings,
                                                "siteStatus",
                                                $$v
                                              )
                                            },
                                            expression: "settings.siteStatus"
                                          }
                                        },
                                        [
                                          _c(
                                            "md-option",
                                            { attrs: { value: "Preview" } },
                                            [_vm._v("Preview")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-option",
                                            { attrs: { value: "Live" } },
                                            [_vm._v("Live")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-option",
                                            { attrs: { value: "Inactive" } },
                                            [_vm._v("Inactive")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("form-site-status.Site status")
                                    ? _c(
                                        "p",
                                        { staticClass: "error m-left-5" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "form-site-status.Site status"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Internal Email Recipients")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          _vm.settings.siteStatus == "Preview"
                                            ? "required"
                                            : "",
                                        expression:
                                          "settings.siteStatus == 'Preview' ? 'required' : ''"
                                      }
                                    ],
                                    attrs: {
                                      name: "Internal email recipients",
                                      placeholder:
                                        "Internal email recipients...",
                                      "md-autogrow": ""
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.settings.emails = _vm.sanitizeInput(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.settings.emails,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.settings,
                                          "emails",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "settings.emails"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "md-helper-text" },
                                    [
                                      _vm._v(
                                        "Multiple email must be comma(,) separated"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-site-status.Internal email recipients"
                                      ),
                                      expression:
                                        "errors.has('form-site-status.Internal email recipients')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-site-status.Internal email recipients"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Super Users")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: _vm.superUserEmailValidate
                                          ? "required"
                                          : "",
                                        expression:
                                          "superUserEmailValidate ? 'required' : ''"
                                      }
                                    ],
                                    attrs: {
                                      name: "super user emails",
                                      placeholder: "Super users emails...",
                                      "md-autogrow": ""
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.settings.super_user_emails = _vm.sanitizeInput(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.settings.super_user_emails,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.settings,
                                          "super_user_emails",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "settings.super_user_emails"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "md-helper-text" },
                                    [
                                      _vm._v(
                                        "Multiple email must be comma(,) separated"
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-site-status.Super Users"
                                      ),
                                      expression:
                                        "errors.has('form-site-status.Super Users')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-site-status.super user emails"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-40 m-left-5"
                                },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Super User Approvals")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-request",
                                          on: {
                                            change: function($event) {
                                              return _vm.validateSuperUser(
                                                "request"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.suApprovalRequest,
                                            callback: function($$v) {
                                              _vm.suApprovalRequest = $$v
                                            },
                                            expression: "suApprovalRequest"
                                          }
                                        },
                                        [_vm._v("Approve Requests")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-response",
                                          on: {
                                            change: function($event) {
                                              return _vm.validateSuperUser(
                                                "response"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.suApprovalResponse,
                                            callback: function($$v) {
                                              _vm.suApprovalResponse = $$v
                                            },
                                            expression: "suApprovalResponse"
                                          }
                                        },
                                        [_vm._v("Approve Responses")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-40 m-left-5 m-top-20"
                                },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Super User Alerts")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-request",
                                          on: {
                                            change: function($event) {
                                              return _vm.validateSuperUser(
                                                "altRequest"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.suAlert.request,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.suAlert,
                                                "request",
                                                $$v
                                              )
                                            },
                                            expression: "suAlert.request"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Community administrator approves requests"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-response",
                                          on: {
                                            change: function($event) {
                                              return _vm.validateSuperUser(
                                                "altResponse"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.suAlert.response,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.suAlert,
                                                "response",
                                                $$v
                                              )
                                            },
                                            expression: "suAlert.response"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Community administrator approves responses"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-response",
                                          on: {
                                            change: function($event) {
                                              return _vm.validateSuperUser(
                                                "altNoResponse"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.suAlert.noResponse,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.suAlert,
                                                "noResponse",
                                                $$v
                                              )
                                            },
                                            expression: "suAlert.noResponse"
                                          }
                                        },
                                        [_vm._v("No response daily alert")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-response",
                                          on: {
                                            change: function($event) {
                                              return _vm.validateSuperUser(
                                                "altFeedback"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.suAlert.feedback,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.suAlert,
                                                "feedback",
                                                $$v
                                              )
                                            },
                                            expression: "suAlert.feedback"
                                          }
                                        },
                                        [_vm._v("Feedback of 4 or less")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-40 m-left-5 m-top-20"
                                },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Super User Management")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-request",
                                          on: {
                                            change: function($event) {
                                              return _vm.validateSuperUser(
                                                "mgmtRequest"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.mgmtRequest,
                                            callback: function($$v) {
                                              _vm.mgmtRequest = $$v
                                            },
                                            expression: "mgmtRequest"
                                          }
                                        },
                                        [_vm._v("Approve Requests")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-response",
                                          on: {
                                            change: function($event) {
                                              return _vm.validateSuperUser(
                                                "mgmtResponse"
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.mgmtResponse,
                                            callback: function($$v) {
                                              _vm.mgmtResponse = $$v
                                            },
                                            expression: "mgmtResponse"
                                          }
                                        },
                                        [_vm._v("Approve Responses")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-raised md-round md-accent m-top-20",
                                  attrs: { type: "submit" }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.saveSiteStatusText) +
                                      "\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box mt-10" },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    { attrs: { "md-alignment": "space-between" } },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "community-expand-button m-left-5" },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.expandchannel(
                                        "communitySetting"
                                      )
                                    }
                                  }
                                },
                                [_vm._v("Settings")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      _c("md-card-content", { staticClass: "card-content" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.opened.includes("communitySetting"),
                                expression:
                                  "opened.includes('communitySetting')"
                              }
                            ],
                            class: {
                              opened: _vm.opened.includes("communitySetting")
                            }
                          },
                          [
                            _c(
                              "form",
                              {
                                attrs: { "data-vv-scope": "form-2" },
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.saveCommunitySetting("form-2")
                                  }
                                }
                              },
                              [
                                _c(
                                  "md-field",
                                  { staticClass: "create-community m-left-5" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "card-header" },
                                      [_vm._v("Community Name:")]
                                    ),
                                    _vm._v(" "),
                                    _c("md-input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        name: "community name",
                                        placeholder: "Community Name"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.community.name = _vm.sanitizeInput(
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.community.name,
                                        callback: function($$v) {
                                          _vm.$set(_vm.community, "name", $$v)
                                        },
                                        expression: "community.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "form-2.community name"
                                        ),
                                        expression:
                                          "errors.has('form-2.community name')"
                                      }
                                    ],
                                    staticClass: "error m-left-5"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "form-2.community name"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-field",
                                  { staticClass: "create-community m-left-5" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "card-header fs-12" },
                                      [_vm._v("Community Code:")]
                                    ),
                                    _vm._v(" "),
                                    _c("md-input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        name: "community code",
                                        placeholder: "Community Code"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.community.code = _vm.sanitizeInput(
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.community.code,
                                        callback: function($$v) {
                                          _vm.$set(_vm.community, "code", $$v)
                                        },
                                        expression: "community.code"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-field",
                                  { staticClass: "create-community m-left-5" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "card-header fs-12" },
                                      [_vm._v("SFTP Username:")]
                                    ),
                                    _vm._v(" "),
                                    _c("md-input", {
                                      attrs: {
                                        name: "SFTP User",
                                        placeholder: "SFTP Username"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.community.sftpUser = _vm.sanitizeInput(
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.community.sftpUser,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.community,
                                            "sftpUser",
                                            $$v
                                          )
                                        },
                                        expression: "community.sftpUser"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-field",
                                  { staticClass: "create-community m-left-5" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "card-header fs-12" },
                                      [_vm._v("SFTP Password:")]
                                    ),
                                    _vm._v(" "),
                                    _c("md-input", {
                                      attrs: {
                                        name: "SFTP Password",
                                        placeholder: "SFTP Password"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.community.sftpPwd = _vm.sanitizeInput(
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.community.sftpPwd,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.community,
                                            "sftpPwd",
                                            $$v
                                          )
                                        },
                                        expression: "community.sftpPwd"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-checkbox",
                                  {
                                    staticClass:
                                      "m-left-5 card-header md-layout",
                                    model: {
                                      value: _vm.community.sftpAutomated,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.community,
                                          "sftpAutomated",
                                          $$v
                                        )
                                      },
                                      expression: "community.sftpAutomated"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Automate Processing of SFTP Uploads"
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-field",
                                  { staticClass: "create-community m-left-5" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "card-header fs-12" },
                                      [_vm._v("Salesforce Organization ID:")]
                                    ),
                                    _vm._v(" "),
                                    _c("md-input", {
                                      attrs: {
                                        name: "Salesforce Org ID",
                                        placeholder:
                                          "Salesforce Organization ID"
                                      },
                                      model: {
                                        value: _vm.community.salesforceOrgId,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.community,
                                            "salesforceOrgId",
                                            $$v
                                          )
                                        },
                                        expression: "community.salesforceOrgId"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "form-2.community code"
                                        ),
                                        expression:
                                          "errors.has('form-2.community code')"
                                      }
                                    ],
                                    staticClass: "error m-left-5"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "form-2.community code"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-field",
                                  { staticClass: "m-left-5" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "card-header" },
                                      [_vm._v("Community Timezone:")]
                                    ),
                                    _vm._v(" "),
                                    _c("md-input", {
                                      attrs: {
                                        placeholder: "Community Timezone"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.community.timezone = _vm.sanitizeInput(
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.community.timezone,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.community,
                                            "timezone",
                                            $$v
                                          )
                                        },
                                        expression: "community.timezone"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "form-group m-left-5" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "card-header" },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t    Location Information\n\t\t\t\t\t\t\t\t    "
                                        ),
                                        _c("img", {
                                          staticClass: "ml-2",
                                          attrs: {
                                            src: require("../assets/tool_tip.svg"),
                                            height: "12",
                                            alt: "tooltip"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "md-tooltip",
                                          {
                                            staticClass: "tool-tip-right",
                                            attrs: { "md-direction": "right" }
                                          },
                                          [
                                            _vm._v(
                                              "Location data required to display Google Map in the Dashboard"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "row mb-3 location-fields"
                                      },
                                      [
                                        _c("div", { staticClass: "col-md-4" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "location-field-wrapper"
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "location-label"
                                                },
                                                [_vm._v("Country")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "location-select-wrapper"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.selectedCountry,
                                                          expression:
                                                            "selectedCountry"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "location-select",
                                                      on: {
                                                        change: [
                                                          function($event) {
                                                            var $$selectedVal = Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function(o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function(o) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                            _vm.selectedCountry = $event
                                                              .target.multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          },
                                                          _vm.onCountryChange
                                                        ]
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "" }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Select Country"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.countries,
                                                        function(country) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              key: country.code,
                                                              domProps: {
                                                                value: country
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t              " +
                                                                  _vm._s(
                                                                    country.name
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t            "
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-4" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "location-field-wrapper"
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "location-label"
                                                },
                                                [_vm._v("State/Province")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "location-select-wrapper"
                                                },
                                                [
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.selectedState,
                                                          expression:
                                                            "selectedState"
                                                        }
                                                      ],
                                                      staticClass:
                                                        "location-select",
                                                      attrs: {
                                                        disabled: !_vm.selectedCountry
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$selectedVal = Array.prototype.filter
                                                            .call(
                                                              $event.target
                                                                .options,
                                                              function(o) {
                                                                return o.selected
                                                              }
                                                            )
                                                            .map(function(o) {
                                                              var val =
                                                                "_value" in o
                                                                  ? o._value
                                                                  : o.value
                                                              return val
                                                            })
                                                          _vm.selectedState = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: { value: "" }
                                                        },
                                                        [_vm._v("Select State")]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        _vm.states,
                                                        function(state) {
                                                          return _c(
                                                            "option",
                                                            {
                                                              key: state,
                                                              domProps: {
                                                                value: state
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n\t\t\t\t\t\t\t\t              " +
                                                                  _vm._s(
                                                                    state
                                                                  ) +
                                                                  "\n\t\t\t\t\t\t\t\t            "
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-md-4" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "location-field-wrapper"
                                            },
                                            [
                                              _c(
                                                "label",
                                                {
                                                  staticClass: "location-label"
                                                },
                                                [_vm._v("City")]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.city,
                                                    expression: "city"
                                                  }
                                                ],
                                                staticClass: "location-input",
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "Enter City"
                                                },
                                                domProps: { value: _vm.city },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.city =
                                                      $event.target.value
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 m-left-5"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md-layout-item md-size-35"
                                      },
                                      [
                                        _c(
                                          "md-field",
                                          [
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for: "communityPortal"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\tUpdate Profile destination\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                ),
                                                _c("img", {
                                                  staticClass: "ml-2",
                                                  attrs: {
                                                    src: require("../assets/tool_tip.svg"),
                                                    height: "12",
                                                    alt: "tooltip"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "md-tooltip",
                                                  {
                                                    staticClass:
                                                      "tool-tip-right",
                                                    attrs: {
                                                      "md-direction": "right"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Choose where members should update their profile data."
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-select",
                                              {
                                                attrs: {
                                                  name: "communityPortal",
                                                  placeholder:
                                                    "Update Profile destination",
                                                  id: "communityPortal"
                                                },
                                                model: {
                                                  value:
                                                    _vm.community
                                                      .communityPortal,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.community,
                                                      "communityPortal",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "community.communityPortal"
                                                }
                                              },
                                              [
                                                _c(
                                                  "md-option",
                                                  {
                                                    attrs: { value: "protopia" }
                                                  },
                                                  [_vm._v("Protopia")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  {
                                                    attrs: { value: "customer" }
                                                  },
                                                  [_vm._v("Customer")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  {
                                                    attrs: { value: "linkedin" }
                                                  },
                                                  [_vm._v("LinkedIn")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.community.communityPortal == "linkedin"
                                  ? _c(
                                      "div",
                                      { staticClass: "md-layout md-gutter" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "md-layout-item md-small-size-60 m-left-5"
                                          },
                                          [
                                            _c(
                                              "md-field",
                                              {
                                                staticClass: "create-community"
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass: "card-header"
                                                  },
                                                  [_vm._v("Client ID:")]
                                                ),
                                                _vm._v(" "),
                                                _c("md-input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: { required: true },
                                                      expression:
                                                        "{ required: true}"
                                                    }
                                                  ],
                                                  attrs: {
                                                    name: "linkedInClientId",
                                                    placeholder: "Client ID"
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      _vm.linkedinCredentials.clientId = _vm.sanitizeInput(
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.linkedinCredentials
                                                        .clientId,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.linkedinCredentials,
                                                        "clientId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "linkedinCredentials.clientId"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "form-2.linkedInClientId"
                                                    ),
                                                    expression:
                                                      "errors.has('form-2.linkedInClientId')"
                                                  }
                                                ],
                                                staticClass: "error"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "form-2.linkedInClientId"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "md-layout-item md-small-size-60 m-left-5"
                                          },
                                          [
                                            _c(
                                              "md-field",
                                              {
                                                staticClass: "create-community"
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass: "card-header"
                                                  },
                                                  [_vm._v("Client Secret:")]
                                                ),
                                                _vm._v(" "),
                                                _c("md-input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: { required: true },
                                                      expression:
                                                        "{ required: true}"
                                                    }
                                                  ],
                                                  attrs: {
                                                    name:
                                                      "linkedInClientSecret",
                                                    placeholder: "Client Secret"
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      _vm.linkedinCredentials.clientId = _vm.sanitizeInput(
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.linkedinCredentials
                                                        .clientSecret,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.linkedinCredentials,
                                                        "clientSecret",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "linkedinCredentials.clientSecret"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "form-2.linkedInClientSecret"
                                                    ),
                                                    expression:
                                                      "errors.has('form-2.linkedInClientSecret')"
                                                  }
                                                ],
                                                staticClass: "error"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "form-2.linkedInClientSecret"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 m-left-5"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md-layout-item md-size-35"
                                      },
                                      [
                                        _c(
                                          "md-field",
                                          { staticClass: "linkedInProfile" },
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "profileLink" } },
                                              [_vm._v("Profile Link?")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-select",
                                              {
                                                attrs: {
                                                  name: "profileLink",
                                                  placeholder: "Profile Link",
                                                  id: "profileLink"
                                                },
                                                model: {
                                                  value:
                                                    _vm.community.profileLink,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.community,
                                                      "profileLink",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "community.profileLink"
                                                }
                                              },
                                              [
                                                _c(
                                                  "md-option",
                                                  { attrs: { value: "none" } },
                                                  [_vm._v("None")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  {
                                                    attrs: {
                                                      value: "customerPortal"
                                                    }
                                                  },
                                                  [_vm._v("Customer Portal")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  {
                                                    attrs: {
                                                      value: "linkedInProfile"
                                                    }
                                                  },
                                                  [_vm._v("LinkedIn Profile")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "md-layout md-gutter md-field"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout-item md-small-size-60 m-left-5"
                                      },
                                      [
                                        _c(
                                          "md-field",
                                          { staticClass: "create-community" },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "card-header" },
                                              [_vm._v("Community Site:")]
                                            ),
                                            _vm._v(" "),
                                            _c("md-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: {
                                                    required:
                                                      _vm.community
                                                        .communityPortal ==
                                                      "customer"
                                                        ? true
                                                        : false,
                                                    regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                                                  },
                                                  expression:
                                                    "{ required: community.communityPortal == 'customer' ? true: false, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                                                }
                                              ],
                                              attrs: {
                                                name: "communitySite",
                                                placeholder:
                                                  "Community Site URL"
                                              },
                                              on: {
                                                input: function($event) {
                                                  _vm.community.communitySite = _vm.sanitizeUrl(
                                                    $event
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.community.communitySite,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.community,
                                                    "communitySite",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "community.communitySite"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "md-helper-text" },
                                              [
                                                _c("strong", [_vm._v("Note:")]),
                                                _vm._v(
                                                  " Community site URL for i.e https://www.example.com"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout-item md-small-size-100"
                                      },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value: _vm.community.syncEnabled,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.community,
                                                  "syncEnabled",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "community.syncEnabled"
                                            }
                                          },
                                          [_vm._v(_vm._s(_vm.changeSyncText))]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("form-2.communitySite")
                                  ? _c("p", { staticClass: "error m-left-5" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errors.first(
                                            "form-2.communitySite"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "m-top-40 m-left-5" },
                                  [
                                    _c(
                                      "md-field",
                                      {
                                        staticClass: "create-community",
                                        class: {
                                          "md-has-value": !!_vm.community
                                            .programPageUrl
                                        }
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "card-header" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\tProgram Page URL\n\t\t\t\t\t\t\t\t\t\t\t"
                                            ),
                                            _c("img", {
                                              staticClass: "ml-2",
                                              attrs: {
                                                src: require("../assets/tool_tip.svg"),
                                                height: "12",
                                                alt: "tooltip"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "md-tooltip",
                                              {
                                                staticClass: "tool-tip-right",
                                                attrs: {
                                                  "md-direction": "right"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "Scopes GA data to this community"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("md-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: {
                                                required: true,
                                                regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                                              },
                                              expression:
                                                "{ required: true, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                                            }
                                          ],
                                          attrs: {
                                            name: "programPageUrl",
                                            placeholder:
                                              "https://xxx.protopia.co"
                                          },
                                          on: {
                                            input: function($event) {
                                              _vm.community.programPageUrl = _vm.ensureHttpsScheme(
                                                _vm.sanitizeUrl($event)
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.community.programPageUrl,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.community,
                                                "programPageUrl",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "community.programPageUrl"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.errors.has("form-2.programPageUrl")
                                  ? _c("p", { staticClass: "error m-left-5" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.errors.first(
                                            "form-2.programPageUrl"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "m-top-40 m-left-5" },
                                  [
                                    _c(
                                      "md-field",
                                      { staticClass: "create-community" },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "card-header" },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t\tGoogle Analytics Property ID\n\t\t\t\t\t\t\t\t\t\t\t"
                                            ),
                                            _c("img", {
                                              staticClass: "ml-2",
                                              attrs: {
                                                src: require("../assets/tool_tip.svg"),
                                                height: "12",
                                                alt: "tooltip"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "md-tooltip",
                                              {
                                                staticClass: "tool-tip-right",
                                                attrs: {
                                                  "md-direction": "right"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "GA Property ID to display Site Visitors in Dashboard"
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("md-input", {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "numeric",
                                              expression: "'numeric'"
                                            }
                                          ],
                                          attrs: {
                                            name: "propertyID",
                                            placeholder: "Property ID"
                                          },
                                          model: {
                                            value: _vm.community.propertyID,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.community,
                                                "propertyID",
                                                $$v
                                              )
                                            },
                                            expression: "community.propertyID"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 m-left-5"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md-layout-item md-size-35"
                                      },
                                      [
                                        _c(
                                          "md-field",
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "emailFormat" } },
                                              [_vm._v("Email Format")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-select",
                                              {
                                                attrs: {
                                                  name: "emailFormat",
                                                  placeholder: "Email Format",
                                                  id: "emailFormat"
                                                },
                                                model: {
                                                  value:
                                                    _vm.community.emailFormat,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.community,
                                                      "emailFormat",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "community.emailFormat"
                                                }
                                              },
                                              [
                                                _c(
                                                  "md-option",
                                                  { attrs: { value: "html" } },
                                                  [_vm._v("Html")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  { attrs: { value: "text" } },
                                                  [_vm._v("Text")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-field",
                                  { staticClass: "m-left-5" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "card-header" },
                                      [_vm._v("Email Sender Name:")]
                                    ),
                                    _vm._v(" "),
                                    _c("md-input", {
                                      attrs: {
                                        name: "sender name",
                                        placeholder: "Email Sender Name"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.community.sender.name = _vm.sanitizeInput(
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.community.sender.name,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.community.sender,
                                            "name",
                                            $$v
                                          )
                                        },
                                        expression: "community.sender.name"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-field",
                                  { staticClass: "create-community m-left-5" },
                                  [
                                    _c(
                                      "label",
                                      { staticClass: "card-header" },
                                      [_vm._v("Email Sender Address:")]
                                    ),
                                    _vm._v(" "),
                                    _c("md-input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "email",
                                          expression: "'email'"
                                        }
                                      ],
                                      attrs: {
                                        name: "sender address",
                                        placeholder: "Email Sender Address"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.community.sender.address = _vm.sanitizeInput(
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.community.sender.address,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.community.sender,
                                            "address",
                                            $$v
                                          )
                                        },
                                        expression: "community.sender.address"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "form-2.sender address"
                                        ),
                                        expression:
                                          "errors.has('form-2.sender address')"
                                      }
                                    ],
                                    staticClass: "error m-left-5"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "form-2.sender address"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100 m-left-5"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "md-layout-item md-size-35"
                                      },
                                      [
                                        _c(
                                          "md-field",
                                          [
                                            _c(
                                              "label",
                                              { attrs: { for: "mapAdviser" } },
                                              [_vm._v("Map Advisers")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-select",
                                              {
                                                attrs: {
                                                  multiple: "",
                                                  name: "mapAdviser",
                                                  placeholder: "Map Advisers",
                                                  id: "mapAdviser"
                                                },
                                                model: {
                                                  value: _vm.mapAdviser,
                                                  callback: function($$v) {
                                                    _vm.mapAdviser = $$v
                                                  },
                                                  expression: "mapAdviser"
                                                }
                                              },
                                              [
                                                _c(
                                                  "md-option",
                                                  {
                                                    attrs: { value: "Student" }
                                                  },
                                                  [_vm._v("Student")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  { attrs: { value: "Alum" } },
                                                  [_vm._v("Alum")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  {
                                                    attrs: { value: "Alumni" }
                                                  },
                                                  [_vm._v("Alumni")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  {
                                                    attrs: { value: "Mentor" }
                                                  },
                                                  [_vm._v("Mentor")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  {
                                                    attrs: {
                                                      value: "Entrepreneur"
                                                    }
                                                  },
                                                  [_vm._v("Entrepreneur")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isSenderEmailAddress
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            staticClass: "m-left-5 card-header",
                                            model: {
                                              value:
                                                _vm.community
                                                  .is_sender_email_address,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.community,
                                                  "is_sender_email_address",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "community.is_sender_email_address"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "Use member email address as sender?"
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass: "m-left-5 card-header",
                                        model: {
                                          value: _vm.community.is_sms_enable,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community,
                                              "is_sms_enable",
                                              $$v
                                            )
                                          },
                                          expression: "community.is_sms_enable"
                                        }
                                      },
                                      [_vm._v("Enable SMS")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.community.is_sms_enable
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "md-layout-item m-left-5"
                                      },
                                      [
                                        _c(
                                          "md-field",
                                          {
                                            staticClass:
                                              "create-community md-small-size-100"
                                          },
                                          [
                                            _c("md-input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: {
                                                    required: true,
                                                    regex: /^\+(?:[0-9] ?){11,11}$/
                                                  },
                                                  expression:
                                                    "{ required: true, regex: /^\\+(?:[0-9] ?){11,11}$/ }"
                                                }
                                              ],
                                              attrs: {
                                                name: "twilio_phone_number",
                                                placeholder:
                                                  "Originating Phone Number"
                                              },
                                              on: {
                                                input: function($event) {
                                                  _vm.community.twilio_phone_number = _vm.sanitizeInput(
                                                    $event
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.community
                                                    .twilio_phone_number,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.community,
                                                    "twilio_phone_number",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "community.twilio_phone_number"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.errors.has(
                                                  "form-2.twilio_phone_number"
                                                ),
                                                expression:
                                                  "errors.has('form-2.twilio_phone_number')"
                                              }
                                            ],
                                            staticClass: "error"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.errors.first(
                                                  "form-2.twilio_phone_number"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass: "m-left-5 card-header",
                                        model: {
                                          value:
                                            _vm.community.member_only_access,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community,
                                              "member_only_access",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.member_only_access"
                                        }
                                      },
                                      [_vm._v("Members – only access")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass:
                                          "m-left-5 card-header md-layout",
                                        model: {
                                          value:
                                            _vm.community
                                              .isAllMembersAreAdvisers,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community,
                                              "isAllMembersAreAdvisers",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.isAllMembersAreAdvisers"
                                        }
                                      },
                                      [_vm._v("All members are advisors")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised md-round md-accent mt-20",
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v(_vm._s(_vm.saveText))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-button",
                                  {
                                    staticClass: "md-raised md-red mt-20",
                                    on: {
                                      click: function($event) {
                                        _vm.active = true
                                      }
                                    }
                                  },
                                  [_vm._v("Delete Community")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-button",
                                  {
                                    staticClass: "md-raised md-yellow mt-20",
                                    attrs: { disabled: _vm.isDisabled },
                                    on: {
                                      click: function($event) {
                                        return _vm.createCommunityCopy()
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.copyText))]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box mt-10" },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    { attrs: { "md-alignment": "space-between" } },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "community-expand-button m-left-5" },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.expandchannel("6")
                                    }
                                  }
                                },
                                [_vm._v("Administrators")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      _c("md-card-content", { staticClass: "card-content" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.opened.includes("6"),
                                expression: "opened.includes('6')"
                              }
                            ],
                            class: { opened: _vm.opened.includes("6") }
                          },
                          [
                            _c("div", { staticClass: "m-left-5" }, [
                              _c(
                                "div",
                                {
                                  class: {
                                    "vue-empty":
                                      _vm.administrators.length <= 0
                                        ? true
                                        : false
                                  }
                                },
                                [
                                  _c(
                                    "md-subheader",
                                    {
                                      staticClass:
                                        "card-header community-subheader"
                                    },
                                    [
                                      _vm._v(
                                        "Community Administrators\n\t\t\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "m-left-10" },
                                        [
                                          _vm.administrators.length < 30
                                            ? _c(
                                                "member-picker",
                                                {
                                                  attrs: {
                                                    selectionType:
                                                      _vm.administrators,
                                                    section: "administrators",
                                                    community:
                                                      _vm.$route.params
                                                        .community_id
                                                  },
                                                  on: {
                                                    chosen:
                                                      _vm.addAdministrators
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "Choose Administrators..."
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        { staticClass: "empty-admin-state" },
                                        [
                                          _c(
                                            "small",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !_vm.administrators
                                                    .length,
                                                  expression:
                                                    "!administrators.length"
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                "Please select administrators"
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.administrators.length
                                    ? _c(
                                        "md-table",
                                        { staticClass: "admin-table" },
                                        [
                                          _c(
                                            "md-table-row",
                                            [
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Name")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Approvals Email")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Escalation Email")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Reports Email")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Members Email")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Alert - Request")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Alert - Response")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Alert - Donor")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Alert - Feedback")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Alert - Referral")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Alert - Unsubscribe")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [
                                                  _vm._v(
                                                    "Alert - Profile Update"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Alert - No Follow-Up")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-table-head",
                                                { staticClass: "card-header" },
                                                [_vm._v("Actions")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.administrators, function(
                                            administrator
                                          ) {
                                            return [
                                              administrator &&
                                              administrator.memberId &&
                                              administrator.memberId._id
                                                ? _c(
                                                    "admin-list",
                                                    {
                                                      key:
                                                        "username_" +
                                                        administrator.memberId
                                                          ._id,
                                                      attrs: {
                                                        member:
                                                          administrator.memberId,
                                                        settings: administrator,
                                                        dataType:
                                                          "administrator"
                                                      },
                                                      on: {
                                                        remove:
                                                          _vm.removeAdministrator
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Administrator goes here..."
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          })
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box mt-10 circle-section" },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    { attrs: { "md-alignment": "left" } },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "community-expand-button m-left-5" },
                            [_vm._v("Circles")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      _c(
                        "md-card-content",
                        { staticClass: "card-content" },
                        [
                          _c("circles", {
                            attrs: { community_id: _vm.community_id }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box mt-10" },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    { attrs: { "md-alignment": "space-between" } },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "community-expand-button" },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.expandchannel("rules")
                                    }
                                  }
                                },
                                [_vm._v("Rules")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      _c(
                        "md-card-content",
                        { staticClass: "rules card-content" },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "form-rules",
                              attrs: {
                                autocomplete: "off",
                                "data-vv-scope": "form-rules"
                              },
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.rulesValidate("form-rules")
                                },
                                change: function($event) {
                                  _vm.saveRulesText = "Save"
                                }
                              }
                            },
                            [
                              _c(
                                "md-field",
                                { staticClass: "create-rule m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v(
                                      "Minimum Matching Threshold for Automated Matching (in %) (Hermes only)"
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          "required|min_value:1|max_value:100",
                                        expression:
                                          "'required|min_value:1|max_value:100'"
                                      }
                                    ],
                                    attrs: { name: "matching_threshold" },
                                    on: {
                                      input: function($event) {
                                        _vm.matchingThreshold = _vm.sanitizeInput(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.matchingThreshold,
                                      callback: function($$v) {
                                        _vm.matchingThreshold = $$v
                                      },
                                      expression: "matchingThreshold"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-rules.matching_threshold"
                                      ),
                                      expression:
                                        "errors.has('form-rules.matching_threshold')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-rules.matching_threshold"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-20"
                                },
                                [
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5 create-rule" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [
                                          _vm._v(
                                            "Advisor Minimum (match this many advisors initially):"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "md-select",
                                        {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "minimum_advisors_ratio",
                                            placeholder:
                                              "minimum_advisors_ratio"
                                          },
                                          model: {
                                            value: _vm.minimum_advisors_ratio,
                                            callback: function($$v) {
                                              _vm.minimum_advisors_ratio = $$v
                                            },
                                            expression: "minimum_advisors_ratio"
                                          }
                                        },
                                        _vm._l(_vm.ratio, function(n) {
                                          return _c(
                                            "md-option",
                                            { key: n, attrs: { value: n } },
                                            [_vm._v(_vm._s(n))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-rules.minimum_advisors_ratio"
                                      ),
                                      expression:
                                        "errors.has('form-rules.minimum_advisors_ratio')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-rules.minimum_advisors_ratio"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-20"
                                },
                                [
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5 create-rule" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [
                                          _vm._v(
                                            "Response Minimum (number of responses needed before stopping auto-matching):"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "md-select",
                                        {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "minimum_responses_ratio"
                                          },
                                          model: {
                                            value: _vm.minimum_responses_ratio,
                                            callback: function($$v) {
                                              _vm.minimum_responses_ratio = $$v
                                            },
                                            expression:
                                              "minimum_responses_ratio"
                                          }
                                        },
                                        _vm._l(_vm.ratio, function(n) {
                                          return _c(
                                            "md-option",
                                            { key: n, attrs: { value: n } },
                                            [_vm._v(_vm._s(n))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-rules.minimum_responses_ratio"
                                      ),
                                      expression:
                                        "errors.has('form-rules.minimum_responses_ratio')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-rules.minimum_responses_ratio"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-20"
                                },
                                [
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5 create-rule" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [
                                          _vm._v(
                                            "Days (wait this many days before auto-matching more advisors):"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "md-select",
                                        {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "days",
                                            placeholder: "days"
                                          },
                                          model: {
                                            value: _vm.days,
                                            callback: function($$v) {
                                              _vm.days = $$v
                                            },
                                            expression: "days"
                                          }
                                        },
                                        _vm._l(_vm.ratio, function(n) {
                                          return _c(
                                            "md-option",
                                            { key: n, attrs: { value: n } },
                                            [_vm._v(_vm._s(n))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("form-rules.days"),
                                      expression:
                                        "errors.has('form-rules.days')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.errors.first("form-rules.days"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-20"
                                },
                                [
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5 create-rule" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [
                                          _vm._v(
                                            "Minimum Advisors (match this many additional advisors if not responded to yet):"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "md-select",
                                        {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value:
                                                "required|max_value:" +
                                                _vm.maximum_advisors,
                                              expression:
                                                "`required|max_value:${maximum_advisors}`"
                                            }
                                          ],
                                          attrs: {
                                            name: "minimum_advisors",
                                            placeholder: "minimum_advisors"
                                          },
                                          model: {
                                            value: _vm.minimum_advisors,
                                            callback: function($$v) {
                                              _vm.minimum_advisors = $$v
                                            },
                                            expression: "minimum_advisors"
                                          }
                                        },
                                        _vm._l(_vm.advisorCount, function(n) {
                                          return _c(
                                            "md-option",
                                            { key: n, attrs: { value: n } },
                                            [_vm._v(_vm._s(n))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-rules.minimum_advisors"
                                      ),
                                      expression:
                                        "errors.has('form-rules.minimum_advisors')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-rules.minimum_advisors"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-20"
                                },
                                [
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5 create-rule" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [
                                          _vm._v(
                                            "Maximum Advisors (total number of advisors that can be matched to a request):"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "md-select",
                                        {
                                          directives: [
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          attrs: {
                                            name: "maximum_advisors",
                                            placeholder: "maximum_advisors"
                                          },
                                          model: {
                                            value: _vm.maximum_advisors,
                                            callback: function($$v) {
                                              _vm.maximum_advisors = $$v
                                            },
                                            expression: "maximum_advisors"
                                          }
                                        },
                                        _vm._l(_vm.advisorCount, function(n) {
                                          return _c(
                                            "md-option",
                                            { key: n, attrs: { value: n } },
                                            [_vm._v(_vm._s(n))]
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-rules.maximum_advisors"
                                      ),
                                      expression:
                                        "errors.has('form-rules.maximum_advisors')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-rules.maximum_advisors"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-40"
                                },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Gemini:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-request",
                                          model: {
                                            value:
                                              _vm.community.rules
                                                .geminiMatching,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.community.rules,
                                                "geminiMatching",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "community.rules.geminiMatching"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Use Gemini to automatically match advisors"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-medium-size-20"
                                    },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "m-left-5 create-rule" },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "card-header" },
                                            [
                                              _vm._v(
                                                "Minimum Terms in Request:"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-select",
                                            {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              attrs: {
                                                name: "geminiMinimumTerms",
                                                placeholder: "minimum terms"
                                              },
                                              model: {
                                                value:
                                                  _vm.community.rules
                                                    .geminiMinimumTerms,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.community.rules,
                                                    "geminiMinimumTerms",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "community.rules.geminiMinimumTerms"
                                              }
                                            },
                                            _vm._l(_vm.advisorCount, function(
                                              n
                                            ) {
                                              return _c(
                                                "md-option",
                                                { key: n, attrs: { value: n } },
                                                [_vm._v(_vm._s(n))]
                                              )
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-40",
                                  staticStyle: { "margin-top": "18px" }
                                },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Approvals:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        gap: "8px",
                                        "align-items": "flex-start"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "1 1 0",
                                            "max-width": "300px"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "md-layout-item md-small-size-100 w-100"
                                            },
                                            [
                                              _c(
                                                "md-checkbox",
                                                {
                                                  staticClass:
                                                    "approval-request",
                                                  model: {
                                                    value:
                                                      _vm.community.rules
                                                        .approvalRequest,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.community.rules,
                                                        "approvalRequest",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "community.rules.approvalRequest"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\tApproval for requesters\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "md-layout-item md-small-size-100 w-100"
                                            },
                                            [
                                              _c(
                                                "md-checkbox",
                                                {
                                                  staticClass:
                                                    "approval-response",
                                                  model: {
                                                    value:
                                                      _vm.community.rules
                                                        .approvalResponse,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.community.rules,
                                                        "approvalResponse",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "community.rules.approvalResponse"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\tApproval for respondents\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "1 1 0",
                                            "max-width": "300px"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "md-layout-item md-small-size-100 w-100"
                                            },
                                            [
                                              _c(
                                                "md-checkbox",
                                                {
                                                  staticClass:
                                                    "approval-response",
                                                  model: {
                                                    value:
                                                      _vm.community.rules
                                                        .AIapprovalRequest,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.community.rules,
                                                        "AIapprovalRequest",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "community.rules.AIapprovalRequest"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t\t\tAI approvals for requests\n\t\t\t\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "error m-left-5" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-40"
                                },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Reminders:")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-request",
                                          model: {
                                            value:
                                              _vm.community.rules
                                                .firstRequestReminder,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.community.rules,
                                                "firstRequestReminder",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "community.rules.firstRequestReminder"
                                          }
                                        },
                                        [_vm._v("Request Reminder 1")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-response",
                                          model: {
                                            value:
                                              _vm.community.rules
                                                .secondRequestReminder,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.community.rules,
                                                "secondRequestReminder",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "community.rules.secondRequestReminder"
                                          }
                                        },
                                        [_vm._v("Request Reminder 2")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-response",
                                          model: {
                                            value:
                                              _vm.community.rules
                                                .feedbackReminder,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.community.rules,
                                                "feedbackReminder",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "community.rules.feedbackReminder"
                                          }
                                        },
                                        [_vm._v("Feedback Reminder")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "error m-left-5" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-40"
                                },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Ask Again Emails")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-response",
                                          model: {
                                            value:
                                              _vm.askAgainFeedbackFrequency.low,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.askAgainFeedbackFrequency,
                                                "low",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "askAgainFeedbackFrequency.low"
                                          }
                                        },
                                        [_vm._v("Feedback Low")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-response",
                                          model: {
                                            value:
                                              _vm.askAgainFeedbackFrequency
                                                .medium,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.askAgainFeedbackFrequency,
                                                "medium",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "askAgainFeedbackFrequency.medium"
                                          }
                                        },
                                        [_vm._v("Feedback Medium")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "md-checkbox",
                                        {
                                          staticClass: "approval-response",
                                          model: {
                                            value:
                                              _vm.askAgainFeedbackFrequency
                                                .high,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.askAgainFeedbackFrequency,
                                                "high",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "askAgainFeedbackFrequency.high"
                                          }
                                        },
                                        [_vm._v("Feedback High")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "error m-left-5" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "md-layout-item" }, [
                                _c("label", { staticClass: "card-header" }, [
                                  _vm._v("Engagement Emails")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-small-size-100 w-100"
                                  },
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass:
                                          "approval-response memberEngagementEmail",
                                        model: {
                                          value:
                                            _vm.community.rules
                                              .memberEngagementEmail,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.rules,
                                              "memberEngagementEmail",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.rules.memberEngagementEmail"
                                        }
                                      },
                                      [
                                        _vm._v("Member Request Reminder "),
                                        _c("span", [
                                          _vm._v(
                                            "(Reminder after 14 days that we're still recruiting advisors)"
                                          )
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "md-layout-item" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-small-size-100 w-100"
                                  },
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass:
                                          "approval-response memberEngagementEmail",
                                        model: {
                                          value:
                                            _vm.community.rules
                                              .feedbackFrequencyToRequest,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.rules,
                                              "feedbackFrequencyToRequest",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.rules.feedbackFrequencyToRequest"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Use Frequency to limit all requests."
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "md-layout-item" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-small-size-100 w-100"
                                  },
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass:
                                          "approval-response memberEngagementEmail",
                                        model: {
                                          value:
                                            _vm.community.rules
                                              .automaticallyCloseRequest,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.rules,
                                              "automaticallyCloseRequest",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.rules.automaticallyCloseRequest"
                                        }
                                      },
                                      [_vm._v("Automatically close requests")]
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "md-layout-item" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-small-size-100 w-100"
                                  },
                                  [
                                    _c("ul", { staticClass: "list-inline" }, [
                                      _c(
                                        "li",
                                        { staticClass: "list-inlne-item" },
                                        [
                                          _c(
                                            "md-checkbox",
                                            {
                                              staticClass:
                                                "approval-response memberEngagementEmail",
                                              model: {
                                                value:
                                                  _vm.community.rules
                                                    .volunteerEscalations,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.community.rules,
                                                    "volunteerEscalations",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "community.rules.volunteerEscalations"
                                              }
                                            },
                                            [_vm._v("Volunteer Escalations")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        { staticClass: "list-inlne-item" },
                                        [
                                          _c(
                                            "md-field",
                                            {
                                              staticClass:
                                                "m-left-5 create-rule"
                                            },
                                            [
                                              _c("md-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value:
                                                      "required|min_value:1|max_value:1000",
                                                    expression:
                                                      "'required|min_value:1|max_value:1000'"
                                                  }
                                                ],
                                                attrs: {
                                                  name: "superEscalatedAdvisors"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    _vm.community.rules.superEscalatedAdvisors = _vm.sanitizeInput(
                                                      $event
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.community.rules
                                                      .superEscalatedAdvisors,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.community.rules,
                                                      "superEscalatedAdvisors",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "community.rules.superEscalatedAdvisors"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "md-layout-item" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-small-size-100 w-100"
                                  },
                                  [
                                    _c("ul", { staticClass: "list-inline" }, [
                                      _c(
                                        "li",
                                        { staticClass: "list-inlne-item" },
                                        [
                                          _c(
                                            "md-checkbox",
                                            {
                                              staticClass:
                                                "approval-response memberEngagementEmail",
                                              model: {
                                                value:
                                                  _vm.community.rules
                                                    .browserNewsletter,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.community.rules,
                                                    "browserNewsletter",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "community.rules.browserNewsletter"
                                              }
                                            },
                                            [_vm._v("Volunteer Digest")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "li",
                                        { staticClass: "list-inline-item" },
                                        [
                                          _c(
                                            "md-field",
                                            {
                                              staticClass:
                                                "m-left-5 create-rule"
                                            },
                                            [
                                              _c(
                                                "md-select",
                                                {
                                                  staticClass: "inline-select",
                                                  attrs: {
                                                    placeholder: "Select Day"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.community.rules
                                                        .browserNewsletterDay,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.community.rules,
                                                        "browserNewsletterDay",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "community.rules.browserNewsletterDay"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "md-option",
                                                    {
                                                      attrs: { value: "Monday" }
                                                    },
                                                    [_vm._v("Monday")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "md-option",
                                                    {
                                                      attrs: {
                                                        value: "Tuesday"
                                                      }
                                                    },
                                                    [_vm._v("Tuesday")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "md-option",
                                                    {
                                                      attrs: {
                                                        value: "Wednesday"
                                                      }
                                                    },
                                                    [_vm._v("Wednesday")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "md-option",
                                                    {
                                                      attrs: {
                                                        value: "Thursday"
                                                      }
                                                    },
                                                    [_vm._v("Thursday")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "md-option",
                                                    {
                                                      attrs: { value: "Friday" }
                                                    },
                                                    [_vm._v("Friday")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "md-option",
                                                    {
                                                      attrs: {
                                                        value: "Saturday"
                                                      }
                                                    },
                                                    [_vm._v("Saturday")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "md-option",
                                                    {
                                                      attrs: { value: "Sunday" }
                                                    },
                                                    [_vm._v("Sunday")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ])
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "error m-left-5" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-medium-size-20 mt-15px"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-small-size-100 w-100"
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [_vm._v("Workflows")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("ul", { staticClass: "list-inline" }, [
                                    _c(
                                      "li",
                                      { staticClass: "list-inline-item" },
                                      [
                                        _c(
                                          "md-field",
                                          {
                                            staticClass: "m-left-5 create-rule"
                                          },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "card-header" },
                                              [
                                                _vm._v(
                                                  "Request Escalation (Days):"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-select",
                                              {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value:
                                                      "required|integer|min_value:1|max_value:30",
                                                    expression:
                                                      "'required|integer|min_value:1|max_value:30'"
                                                  }
                                                ],
                                                attrs: {
                                                  name: "requestEscalation",
                                                  placeholder:
                                                    "Select escalation days"
                                                },
                                                model: {
                                                  value:
                                                    _vm.community.rules.workflow
                                                      .requestEscalation,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.community.rules
                                                        .workflow,
                                                      "requestEscalation",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "community.rules.workflow.requestEscalation"
                                                }
                                              },
                                              _vm._l(30, function(n) {
                                                return _c(
                                                  "md-option",
                                                  {
                                                    key: n,
                                                    attrs: { value: n }
                                                  },
                                                  [_vm._v(_vm._s(n))]
                                                )
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("ul", { staticClass: "list-inline" }, [
                                    _c(
                                      "li",
                                      { staticClass: "list-inlne-item" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            staticClass: "menteeReminder",
                                            model: {
                                              value:
                                                _vm.community.rules.workflow
                                                  .menteeReminder,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.community.rules.workflow,
                                                  "menteeReminder",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "community.rules.workflow.menteeReminder"
                                            }
                                          },
                                          [_vm._v("Mentee Reminder")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      { staticClass: "list-inline-item" },
                                      [
                                        _c(
                                          "md-field",
                                          {
                                            staticClass: "m-left-5 create-rule"
                                          },
                                          [
                                            _c(
                                              "md-select",
                                              {
                                                attrs: {
                                                  name: "type",
                                                  placeholder: "Reminder Type"
                                                },
                                                model: {
                                                  value:
                                                    _vm.community.rules.workflow
                                                      .type,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.community.rules
                                                        .workflow,
                                                      "type",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "community.rules.workflow.type"
                                                }
                                              },
                                              [
                                                _c(
                                                  "md-option",
                                                  {
                                                    attrs: { value: "Weekly" }
                                                  },
                                                  [_vm._v("Weekly")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "md-option",
                                                  {
                                                    attrs: { value: "Monthly" }
                                                  },
                                                  [_vm._v("Monthly")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("ul", { staticClass: "list-inline" }, [
                                    _c(
                                      "li",
                                      { staticClass: "list-inlne-item" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            staticClass: "moduleResources",
                                            model: {
                                              value:
                                                _vm.community.rules.workflow
                                                  .moduleResources,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.community.rules.workflow,
                                                  "moduleResources",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "community.rules.workflow.moduleResources"
                                            }
                                          },
                                          [_vm._v("Module - Resources")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "li",
                                      { staticClass: "list-inline-item" },
                                      [
                                        _c(
                                          "md-field",
                                          {
                                            staticClass: "m-left-5 create-rule"
                                          },
                                          [
                                            _c(
                                              "label",
                                              { staticClass: "card-header" },
                                              [
                                                _vm._v(
                                                  "Max Resources to Include:"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-select",
                                              {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value:
                                                      "required|integer|min_value:max_value:10",
                                                    expression:
                                                      "'required|integer|min_value:max_value:10'"
                                                  }
                                                ],
                                                attrs: {
                                                  name: "maxResources",
                                                  placeholder:
                                                    "Select max resources"
                                                },
                                                model: {
                                                  value:
                                                    _vm.community.rules.workflow
                                                      .maxResources,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.community.rules
                                                        .workflow,
                                                      "maxResources",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "community.rules.workflow.maxResources"
                                                }
                                              },
                                              _vm._l(10, function(n) {
                                                return _c(
                                                  "md-option",
                                                  {
                                                    key: n,
                                                    attrs: { value: n }
                                                  },
                                                  [_vm._v(_vm._s(n))]
                                                )
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "md-layout-item" }, [
                                _c("label", { staticClass: "card-header" }, [
                                  _vm._v("Semester Summary")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-small-size-100 w-100"
                                  },
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass:
                                          "approval-response memberEngagementEmail",
                                        model: {
                                          value: _vm.semesterSummary.member,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.semesterSummary,
                                              "member",
                                              $$v
                                            )
                                          },
                                          expression: "semesterSummary.member"
                                        }
                                      },
                                      [_vm._v("Members")]
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("SemesterDateBlock", {
                                ref: "dateBlock1",
                                attrs: {
                                  label: "Date 1",
                                  date: _vm.semesterSummary.date1,
                                  range: _vm.semesterSummary.range1
                                },
                                on: {
                                  "update:date": function($event) {
                                    return _vm.$set(
                                      _vm.semesterSummary,
                                      "date1",
                                      $event
                                    )
                                  },
                                  "update:range": function($event) {
                                    return _vm.$set(
                                      _vm.semesterSummary,
                                      "range1",
                                      $event
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("SemesterDateBlock", {
                                ref: "dateBlock2",
                                attrs: {
                                  label: "Date 2",
                                  date: _vm.semesterSummary.date2,
                                  range: _vm.semesterSummary.range2
                                },
                                on: {
                                  "update:date": function($event) {
                                    return _vm.$set(
                                      _vm.semesterSummary,
                                      "date2",
                                      $event
                                    )
                                  },
                                  "update:range": function($event) {
                                    return _vm.$set(
                                      _vm.semesterSummary,
                                      "range2",
                                      $event
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("SemesterDateBlock", {
                                ref: "dateBlock3",
                                attrs: {
                                  label: "Date 3",
                                  date: _vm.semesterSummary.date3,
                                  range: _vm.semesterSummary.range3
                                },
                                on: {
                                  "update:date": function($event) {
                                    return _vm.$set(
                                      _vm.semesterSummary,
                                      "date3",
                                      $event
                                    )
                                  },
                                  "update:range": function($event) {
                                    return _vm.$set(
                                      _vm.semesterSummary,
                                      "range3",
                                      $event
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("SemesterDateBlock", {
                                ref: "dateBlock4",
                                attrs: {
                                  label: "Date 4",
                                  date: _vm.semesterSummary.date4,
                                  range: _vm.semesterSummary.range4
                                },
                                on: {
                                  "update:date": function($event) {
                                    return _vm.$set(
                                      _vm.semesterSummary,
                                      "date4",
                                      $event
                                    )
                                  },
                                  "update:range": function($event) {
                                    return _vm.$set(
                                      _vm.semesterSummary,
                                      "range4",
                                      $event
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "mt-20 md-raised md-round md-accent",
                                  attrs: { type: "submit" }
                                },
                                [_vm._v(_vm._s(_vm.saveRulesText))]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("community-recruiting-config", {
        attrs: { community: _vm.community }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box mt-10" },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    { attrs: { "md-alignment": "space-between" } },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "community-expand-button m-left-5" },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.expandchannel("7")
                                    }
                                  }
                                },
                                [_vm._v("Partner Communities")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      _c(
                        "md-card-content",
                        {
                          staticClass:
                            "custom-checkbox-partner-communities card-content"
                        },
                        [
                          _c(
                            "form",
                            {
                              staticClass: "form-partner-community",
                              attrs: {
                                autocomplete: "off",
                                "data-vv-scope": "form-partner-community"
                              },
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.updatePartnerCommunity()
                                }
                              }
                            },
                            [
                              _c("partner-community-list", {
                                attrs: {
                                  pCommunity: _vm.communities,
                                  mCommunity: _vm.community,
                                  dataType: "partnerCommunity"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.community.customSettings
        ? _c(
            "div",
            { staticClass: "box mt-10" },
            [
              _c(
                "md-card",
                [
                  _c(
                    "md-card-expand",
                    [
                      _c(
                        "md-card-actions",
                        { attrs: { "md-alignment": "space-between" } },
                        [
                          _c(
                            "md-card-expand-trigger",
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "community-expand-button m-left-5"
                                },
                                [_vm._v("Styling")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-card-expand-content",
                        [
                          _c(
                            "md-card-content",
                            { staticClass: "card-content" },
                            [
                              _c(
                                "form",
                                {
                                  attrs: {
                                    autocomplete: "off",
                                    "data-vv-scope": "style-setting"
                                  },
                                  on: {
                                    submit: function($event) {
                                      $event.preventDefault()
                                      return _vm.saveStyle("style-setting")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [_vm._v("Community Logo (250 x 50)")]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        attrs: { placeholder: "Logo URL" },
                                        on: {
                                          input: function($event) {
                                            _vm.community.customSettings.logoURL = _vm.sanitizeUrl(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .logoURL,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "logoURL",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.logoURL"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [_vm._v("Community Favicon (16 x 16)")]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        attrs: { placeholder: "Logo URL" },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .faviconURL,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "faviconURL",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.faviconURL"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [_vm._v("Community Icon (100 x 100)")]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        attrs: { placeholder: "Icon URL" },
                                        on: {
                                          input: function($event) {
                                            _vm.community.customSettings.iconURL = _vm.sanitizeUrl(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .iconURL,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "iconURL",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.iconURL"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [_vm._v("Organization Logo (150 x 40)")]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        attrs: {
                                          placeholder: "Organization URL"
                                        },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .organizationURL,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "organizationURL",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.organizationURL"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [_vm._v("Organization Logo (150 x 40)")]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        attrs: {
                                          placeholder: "Organization URL"
                                        },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .organizationURL,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "organizationURL",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.organizationURL"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [_vm._v("Background Color:")]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        attrs: {
                                          placeholder: "Background Color"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.community.customSettings.primaryColor = _vm.sanitizeCss(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .primaryColor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "primaryColor",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.primaryColor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [_vm._v("Text Color:")]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        attrs: { placeholder: "Text Color" },
                                        on: {
                                          input: function($event) {
                                            _vm.community.customSettings.secondaryColor = _vm.sanitizeCss(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .secondaryColor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "secondaryColor",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.secondaryColor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5 create-rule" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [
                                          _vm._v(
                                            "Primary Button Background Color:"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required: true,
                                              regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
                                            },
                                            expression:
                                              "{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }"
                                          }
                                        ],
                                        attrs: {
                                          name: "primaryBtnBgColor",
                                          type: "text",
                                          placeholder:
                                            "Primary Button Background Color"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.community.customSettings.primaryBtnBgColor = _vm.sanitizeCss(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .primaryBtnBgColor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "primaryBtnBgColor",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.primaryBtnBgColor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has(
                                    "style-setting.primaryBtnBgColor"
                                  )
                                    ? _c(
                                        "p",
                                        { staticClass: "error m-left-5" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "style-setting.primaryBtnBgColor"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5 create-rule" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [_vm._v("Primary Button Text Color:")]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required: true,
                                              regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
                                            },
                                            expression:
                                              "{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }"
                                          }
                                        ],
                                        attrs: {
                                          name: "primaryTxtColor",
                                          type: "text",
                                          placeholder:
                                            "Primary Button Text Color"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.community.customSettings.primaryTxtColor = _vm.sanitizeCss(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .primaryTxtColor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "primaryTxtColor",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.primaryTxtColor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has(
                                    "style-setting.primaryTxtColor"
                                  )
                                    ? _c(
                                        "p",
                                        { staticClass: "error m-left-5" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "style-setting.primaryTxtColor"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5 create-rule" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [
                                          _vm._v(
                                            "Secondary Button Background Color:"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required: true,
                                              regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
                                            },
                                            expression:
                                              "{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }"
                                          }
                                        ],
                                        attrs: {
                                          name: "secondaryBtnBgColor",
                                          type: "text",
                                          placeholder:
                                            "Secondary Button Background Color"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.community.customSettings.secondaryBtnBgColor = _vm.sanitizeCss(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .secondaryBtnBgColor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "secondaryBtnBgColor",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.secondaryBtnBgColor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has(
                                    "style-setting.secondaryBtnBgColor"
                                  )
                                    ? _c(
                                        "p",
                                        { staticClass: "error m-left-5" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "style-setting.secondaryBtnBgColor"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5 create-rule" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [_vm._v("Secondary Button Text Color:")]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required: true,
                                              regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
                                            },
                                            expression:
                                              "{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }"
                                          }
                                        ],
                                        attrs: {
                                          name: "secondaryTxtColor",
                                          type: "text",
                                          placeholder:
                                            "Secondary Button Text Color"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.community.customSettings.secondaryTxtColor = _vm.sanitizeCss(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .secondaryTxtColor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "secondaryTxtColor",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.secondaryTxtColor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has(
                                    "style-setting.secondaryTxtColor"
                                  )
                                    ? _c(
                                        "p",
                                        { staticClass: "error m-left-5" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "style-setting.secondaryTxtColor"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5 create-rule" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [
                                          _vm._v(
                                            "Third Customizable Background Color:"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required: true,
                                              regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
                                            },
                                            expression:
                                              "{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }"
                                          }
                                        ],
                                        attrs: {
                                          name: "thirdBtnBgColor",
                                          type: "text",
                                          placeholder:
                                            "Third Customizable Button Background Color"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.community.customSettings.thirdBtnBgColor = _vm.sanitizeCss(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .thirdBtnBgColor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "thirdBtnBgColor",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.thirdBtnBgColor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has(
                                    "style-setting.thirdBtnBgColor"
                                  )
                                    ? _c(
                                        "p",
                                        { staticClass: "error m-left-5" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "style-setting.thirdBtnBgColor"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "md-field",
                                    { staticClass: "m-left-5 create-rule" },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [
                                          _vm._v(
                                            "Third Customizable Text Color:"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required: true,
                                              regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
                                            },
                                            expression:
                                              "{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }"
                                          }
                                        ],
                                        attrs: {
                                          name: "thirdTxtColor",
                                          type: "text",
                                          placeholder:
                                            "Third Customizable Button Text Color"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.community.customSettings.thirdTxtColor = _vm.sanitizeCss(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.community.customSettings
                                              .thirdTxtColor,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.community.customSettings,
                                              "thirdTxtColor",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "community.customSettings.thirdTxtColor"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("style-setting.thirdTxtColor")
                                    ? _c(
                                        "p",
                                        { staticClass: "error m-left-5" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "style-setting.thirdTxtColor"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "md-button",
                                    {
                                      staticClass:
                                        "mt-20 md-raised md-round md-accent",
                                      attrs: { type: "submit" }
                                    },
                                    [_vm._v(_vm._s(_vm.saveStyleText))]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box mt-10" },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    { attrs: { "md-alignment": "space-between" } },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "community-expand-button m-left-5" },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.expandchannel("request")
                                    }
                                  }
                                },
                                [_vm._v("Request")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      _c("md-card-content", { staticClass: "card-content" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.opened.includes("request"),
                                expression: "opened.includes('request')"
                              }
                            ],
                            class: { opened: _vm.opened.includes("request") }
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-12" }, [
                                _c("div", { staticClass: "col-md-4" }),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-4" }, [
                                  _c("h4", { staticClass: "mt-18" }, [
                                    _vm._v("Request Form")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-md-4" }, [
                                  _c("h4", { staticClass: "mt-18" }, [
                                    _vm._v("Bot")
                                  ])
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "form",
                              {
                                attrs: { "data-vv-scope": "form-content" },
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.addRequestContent("form-content")
                                  },
                                  change: function($event) {
                                    _vm.requestSaveContentText = "save"
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("First Name")])]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "firstNameLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "firstName"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.firstName.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.firstName
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.firstName,
                                                  "labelName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.firstName.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "firstNameLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "firstName"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.firstName.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.firstName
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.firstName,
                                                  "chatbotLabelName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.firstName.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Last Name")])]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "lastNameLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "lastName"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.lastName.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.lastName
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.lastName,
                                                  "labelName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.lastName.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "lastNameLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "lastName"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.lastName.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.lastName
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.lastName,
                                                  "chatbotLabelName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.lastName.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Email Address")])]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "emailAddressLabel"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "emailAddress"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.emailAddress.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.emailAddress
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .emailAddress,
                                                  "labelName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.emailAddress.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "emailAddressLabel"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "emailAddress"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.emailAddress.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.emailAddress
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .emailAddress,
                                                  "chatbotLabelName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.emailAddress.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Subject")])]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "subjectLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "subject"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.subject.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.subject
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.subject,
                                                  "labelName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.subject.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "subjectLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "subject"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.subject.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.subject
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.subject,
                                                  "chatbotLabelName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.subject.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [
                                        _c("label", [
                                          _vm._v("Subject placeholder")
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            attrs: {
                                              name: "requestForm.subjectLine",
                                              placeholder:
                                                "Request Form - Subject Line"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.requestForm.subjectLine = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.requestForm.subjectLine,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.requestForm,
                                                  "subjectLine",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "requestForm.subjectLine"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "form-content.subjectLine"
                                              ),
                                              expression:
                                                "errors.has('form-content.subjectLine')"
                                            }
                                          ],
                                          staticClass: "error m-left-5"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.errors.first(
                                                "form-content.subjectLine"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Question")])]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "questionLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "question"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.question.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.question
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.question,
                                                  "labelName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.question.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "questionLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "question"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.question.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.question
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.question,
                                                  "chatbotLabelName",
                                                  typeof $$v === "string"
                                                    ? $$v.trim()
                                                    : $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.question.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [
                                        _c("label", [
                                          _vm._v("Question placeholder")
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            attrs: {
                                              name: "requestForm.question",
                                              placeholder:
                                                "Request Form - Question"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.requestForm.question = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.requestForm.question,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.requestForm,
                                                  "question",
                                                  $$v
                                                )
                                              },
                                              expression: "requestForm.question"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Member Role")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.memberRole
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .memberRole,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.memberRole.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.memberRole
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .memberRole,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.memberRole.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "memberRoleLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "memberRole"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.memberRole.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.memberRole
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .memberRole,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.memberRole.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "memberRoleLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "memberRole"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.memberRole.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.memberRole
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .memberRole,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.memberRole.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c("div", {
                                      staticClass: "col-md-4 mt-10"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }, [
                                      _c("label", { staticClass: "mt-18" }, [
                                        _vm._v("Values:")
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "memberRoleValue" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "memberRoleValue"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.memberRole.value = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.memberRole
                                                  .value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .memberRole,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.memberRole.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.memberRoleValue
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "error error-custom-position"
                                            },
                                            [
                                              _vm._v(
                                                "Options values should not be more than 15."
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "chatbotMemberRoleValue"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "chatbotMemberRoleValue"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.memberRole.chatbotValue = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.memberRole
                                                  .chatbotValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .memberRole,
                                                  "chatbotValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.memberRole.chatbotValue"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.chatbotMemberRoleValue
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "error error-custom-position"
                                            },
                                            [
                                              _vm._v(
                                                "Options values should not be more than 15."
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Advice Area")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.adviceArea
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .adviceArea,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.adviceArea.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.adviceArea
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .adviceArea,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.adviceArea.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "adviceAreaLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "adviceArea"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.adviceArea.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.adviceArea
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .adviceArea,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.adviceArea.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "adviceAreaLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "adviceArea"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.adviceArea.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.adviceArea
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .adviceArea,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.adviceArea.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c("div", {
                                      staticClass: "col-md-4 mt-10"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }, [
                                      _c("label", { staticClass: "mt-18" }, [
                                        _vm._v("Values:")
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "adviceAreaValue" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "adviceAreaValue"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.adviceArea.value = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.adviceArea
                                                  .value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .adviceArea,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.adviceArea.value"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.adviceAreaValue
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "error error-custom-position"
                                            },
                                            [
                                              _vm._v(
                                                "Options values should not be more than 6."
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "chatbotAdviceAreaValue"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "chatbotAdviceAreaValue"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.adviceArea.chatbotValue = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.adviceArea
                                                  .chatbotValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .adviceArea,
                                                  "chatbotValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.adviceArea.chatbotValue"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.chatbotAdviceAreaValue
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "error error-custom-position"
                                            },
                                            [
                                              _vm._v(
                                                "Options values should not be more than 6."
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [
                                        _c("label", [
                                          _vm._v("College / Program")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.college
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.college,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.college.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.college
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.college,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.college.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "collegeLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "collegeLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.college.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.college
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.college,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.college.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "collegeLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "collegeLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.college.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.college
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.college,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.college.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [
                                        _c("label", [
                                          _vm._v("College / Program (Dropdown)")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.college2
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.college2,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.college2.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.college2
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.college2,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.college2.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "college2Label" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "college2Label"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.college2.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.college2
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.college2,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.college2.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "college2Label" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "college2Label"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.college2.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.college2
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.college2,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.college2.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c("div", {
                                      staticClass: "col-md-4 mt-10"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }, [
                                      _c("label", { staticClass: "mt-18" }, [
                                        _vm._v("Values:")
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "college2Value" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "college2Value"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.college2.value = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.college2
                                                  .value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.college2,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.college2.value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "college2Value" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "college2Value"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.college2.chatbotValue = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.college2
                                                  .chatbotValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.college2,
                                                  "chatbotValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.college2.chatbotValue"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [
                                        _c("label", [
                                          _vm._v("Major (Dropdown)")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.major
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.major,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.major.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.major
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.major,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.major.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "majorLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "majorLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.major.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.major
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.major,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.major.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "majorLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "majorLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.major.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.major
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.major,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.major.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c("div", {
                                      staticClass: "col-md-4 mt-10"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }, [
                                      _c("label", { staticClass: "mt-18" }, [
                                        _vm._v("Values:")
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "majorValue" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "majorValue"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.major.value = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.major.value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.major,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.major.value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "majorValue" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "majorValue"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.major.chatbotValue = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.major
                                                  .chatbotValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.major,
                                                  "chatbotValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.major.chatbotValue"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Class Year")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.classYear
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.classYear,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.classYear.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.classYear
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.classYear,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.classYear.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "classYearLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "classYearLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.classYear.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.classYear
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.classYear,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.classYear.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "classYearLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "classYearLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.classYear.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.classYear
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.classYear,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.classYear.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [
                                        _c("label", [
                                          _vm._v("Class Year (Dropdown)")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.classYear2
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .classYear2,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.classYear2.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.classYear2
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .classYear2,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.classYear2.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "classYear2Label" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "classYear2Label"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.classYear2.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.classYear2
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .classYear2,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.classYear2.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "classYear2Label" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "classYear2Label"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.classYear2.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.classYear2
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .classYear2,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.classYear2.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c("div", {
                                      staticClass: "col-md-4 mt-10"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }, [
                                      _c("label", { staticClass: "mt-18" }, [
                                        _vm._v("Values:")
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "classYear2Value" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "classYear2Value"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.classYear2.value = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.classYear2
                                                  .value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .classYear2,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.classYear2.value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "classYear2Value" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "classYear2Value"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.classYear2.chatbotValue = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.classYear2
                                                  .chatbotValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .classYear2,
                                                  "chatbotValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.classYear2.chatbotValue"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Title")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.title
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.title,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.title.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.title
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.title,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.title.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "titleLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "titleLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.title.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.title
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.title,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.title.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "titleLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "titleLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.title.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.title
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.title,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.title.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Organization")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.organization
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .organization,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.organization.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.organization
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .organization,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.organization.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "organizationLabel"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "organizationLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.organization.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.organization
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .organization,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.organization.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "organizationLabel"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "organizationLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.organization.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.organization
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .organization,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.organization.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Student ID")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.studentId
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.studentId,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.studentId.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.studentId
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.studentId,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.studentId.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "studentIdLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "studentLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.studentId.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.studentId
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.studentId,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.studentId.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "studentIdLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "studentLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.studentId.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.studentId
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.studentId,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.studentId.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Due Date")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.dueDate
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.dueDate,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.dueDate.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.dueDate
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.dueDate,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.dueDate.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "dueDateLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "dueDateLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.dueDate.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.dueDate
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.dueDate,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.dueDate.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "dueDateLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "dueDateLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.dueDate.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.dueDate
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.dueDate,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.dueDate.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [
                                        _c("label", [
                                          _vm._v("LinkedIn profile")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields
                                                  .linkedInProfile.include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .linkedInProfile,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.linkedInProfile.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields
                                                  .linkedInProfile.require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .linkedInProfile,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.linkedInProfile.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "linkedInProfileLabel"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "linkedInProfileLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.linkedInProfile.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields
                                                  .linkedInProfile.labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .linkedInProfile,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.linkedInProfile.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "linkedInProfileLabel"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "linkedInProfileLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.linkedInProfile.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields
                                                  .linkedInProfile
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .linkedInProfile,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.linkedInProfile.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Phone Number")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.phoneNumber
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .phoneNumber,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.phoneNumber.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.phoneNumber
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .phoneNumber,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.phoneNumber.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "phoneNumberLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "phoneNumberLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.phoneNumber.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.phoneNumber
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .phoneNumber,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.phoneNumber.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "phoneNumberLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "phoneNumberLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.phoneNumber.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.phoneNumber
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .phoneNumber,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.phoneNumber.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Referrer")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.referrer
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.referrer,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.referrer.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.referrer
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.referrer,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.referrer.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "sourceLabel" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "sourceLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.referrer.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.referrer
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.referrer,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.referrer.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [
                                        _c("label", [
                                          _vm._v("Referrer (Dropdown)")
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.referrer2
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.referrer2,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.referrer2.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.referrer2
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.referrer2,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.referrer2.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "referrer2Label" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "referrer2Label"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.referrer2.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.referrer2
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.referrer2,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.referrer2.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c("div", {
                                      staticClass: "col-md-4 mt-10"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }, [
                                      _c("label", { staticClass: "mt-18" }, [
                                        _vm._v("Values:")
                                      ])
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-8" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: { name: "referrer2Value" },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "referrer2Value"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.referrer2.value = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.referrer2
                                                  .value,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.referrer2,
                                                  "value",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.referrer2.value"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Disclaimer")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.disclaimer
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .disclaimer,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.disclaimer.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.disclaimer
                                                  .require,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .disclaimer,
                                                  "require",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.disclaimer.require"
                                            }
                                          },
                                          [_vm._v("Required")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4 custom-textarea" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-textarea", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate.continues",
                                                value: "max:2000",
                                                expression: "'max:2000'",
                                                modifiers: { continues: true }
                                              }
                                            ],
                                            attrs: {
                                              maxlength: 2000,
                                              name: "disclaimerLabel",
                                              placeholder:
                                                "Enter disclaimer here"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "disclaimerLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.disclaimer.labelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.disclaimer
                                                  .labelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .disclaimer,
                                                  "labelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.disclaimer.labelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4 custom-textarea" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-textarea", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate.continues",
                                                value: "max:2000",
                                                expression: "'max:2000'",
                                                modifiers: { continues: true }
                                              }
                                            ],
                                            attrs: {
                                              maxlength: 2000,
                                              name: "disclaimerLabel",
                                              placeholder:
                                                "Enter disclaimer here"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "disclaimerLabel"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.disclaimer.chatbotLabelName = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.disclaimer
                                                  .chatbotLabelName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields
                                                    .disclaimer,
                                                  "chatbotLabelName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.disclaimer.chatbotLabelName"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("hr", {
                                  staticClass: "request-hr m-left-5"
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Interest")])]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4" },
                                      [
                                        _c(
                                          "md-checkbox",
                                          {
                                            model: {
                                              value:
                                                _vm.configureFields.interest
                                                  .include,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.interest,
                                                  "include",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.interest.include"
                                            }
                                          },
                                          [_vm._v("Include")]
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-4 custom-textarea" },
                                    [
                                      _c(
                                        "md-field",
                                        { staticClass: "mt--6" },
                                        [
                                          _c("md-textarea", {
                                            staticClass:
                                              "community-interest-description",
                                            attrs: {
                                              name: "description",
                                              placeholder:
                                                "Enter interest description",
                                              rows: "5"
                                            },
                                            on: {
                                              blur: function($event) {
                                                return _vm.labelValidate(
                                                  "description"
                                                )
                                              },
                                              input: function($event) {
                                                _vm.configureFields.interest.description = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.configureFields.interest
                                                  .description,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.configureFields.interest,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "configureFields.interest.description"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row mt-30" }, [
                                  _c("div", { staticClass: "col-md-4" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-md-4 mt-10" },
                                      [_c("label", [_vm._v("Profile Updates")])]
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12 col-sm-6" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-1 mt-15" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tInterests\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-2" },
                                        [
                                          _c(
                                            "md-field",
                                            { staticClass: "mt--6 mb-0" },
                                            [
                                              _c(
                                                "md-select",
                                                {
                                                  attrs: {
                                                    name:
                                                      "profileUpdateInterest",
                                                    placeholder: "Interests"
                                                  },
                                                  on: {
                                                    "md-selected": function(
                                                      $event
                                                    ) {
                                                      return _vm.changeProfileUpdate(
                                                        _vm.configureFields
                                                          .profileUpdateInterest,
                                                        "interests"
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.configureFields
                                                        .profileUpdateInterest,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.configureFields,
                                                        "profileUpdateInterest",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "configureFields.profileUpdateInterest"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.defaultProfileUpdateList,
                                                  function(value, index) {
                                                    return _c(
                                                      "md-option",
                                                      {
                                                        key: index,
                                                        attrs: { value: index }
                                                      },
                                                      [_vm._v(_vm._s(value))]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12 col-sm-6" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-1 mt-15" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tOccupation\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-2" },
                                        [
                                          _c(
                                            "md-field",
                                            { staticClass: "mt--6 mb-0" },
                                            [
                                              _c(
                                                "md-select",
                                                {
                                                  attrs: {
                                                    name:
                                                      "profileUpdateOccupation",
                                                    placeholder: "Occupation"
                                                  },
                                                  on: {
                                                    "md-selected": function(
                                                      $event
                                                    ) {
                                                      return _vm.changeProfileUpdate(
                                                        _vm.configureFields
                                                          .profileUpdateOccupation,
                                                        "occupation"
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.configureFields
                                                        .profileUpdateOccupation,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.configureFields,
                                                        "profileUpdateOccupation",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "configureFields.profileUpdateOccupation"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.defaultProfileUpdateList,
                                                  function(value, index) {
                                                    return _c(
                                                      "md-option",
                                                      {
                                                        key: index,
                                                        attrs: { value: index }
                                                      },
                                                      [_vm._v(_vm._s(value))]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12 col-sm-6" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-1 mt-15" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tGeography\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-2" },
                                        [
                                          _c(
                                            "md-field",
                                            { staticClass: "mt--6 mb-0" },
                                            [
                                              _c(
                                                "md-select",
                                                {
                                                  attrs: {
                                                    name:
                                                      "profileUpdateGeography",
                                                    placeholder: "Geography"
                                                  },
                                                  on: {
                                                    "md-selected": function(
                                                      $event
                                                    ) {
                                                      return _vm.changeProfileUpdate(
                                                        _vm.configureFields
                                                          .profileUpdateGeography,
                                                        "geography"
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.configureFields
                                                        .profileUpdateGeography,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.configureFields,
                                                        "profileUpdateGeography",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "configureFields.profileUpdateGeography"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.defaultProfileUpdateList,
                                                  function(value, index) {
                                                    return _c(
                                                      "md-option",
                                                      {
                                                        key: index,
                                                        attrs: { value: index }
                                                      },
                                                      [_vm._v(_vm._s(value))]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12 col-sm-6" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-1 mt-15" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tLinkedIn URL\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-2" },
                                        [
                                          _c(
                                            "md-field",
                                            { staticClass: "mt--6 mb-0" },
                                            [
                                              _c(
                                                "md-select",
                                                {
                                                  attrs: {
                                                    name:
                                                      "profileUpdateLinkedInUrl",
                                                    placeholder: "LinkedIn Url"
                                                  },
                                                  on: {
                                                    "md-selected": function(
                                                      $event
                                                    ) {
                                                      return _vm.changeProfileUpdate(
                                                        _vm.configureFields
                                                          .profileUpdateLinkedInUrl,
                                                        "linkedInUrl"
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.configureFields
                                                        .profileUpdateLinkedInUrl,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.configureFields,
                                                        "profileUpdateLinkedInUrl",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "configureFields.profileUpdateLinkedInUrl"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.defaultProfileUpdateList,
                                                  function(value, index) {
                                                    return _c(
                                                      "md-option",
                                                      {
                                                        key: index,
                                                        attrs: { value: index }
                                                      },
                                                      [_vm._v(_vm._s(value))]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12 col-sm-6" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-1 mt-15" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t\t\t\t\tPhone Number\n\t\t\t\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-2" },
                                        [
                                          _c(
                                            "md-field",
                                            { staticClass: "mt--6 mb-0" },
                                            [
                                              _c(
                                                "md-select",
                                                {
                                                  attrs: {
                                                    name:
                                                      "profileUpdatePhoneNumber",
                                                    placeholder: "Phone number"
                                                  },
                                                  on: {
                                                    "md-selected": function(
                                                      $event
                                                    ) {
                                                      return _vm.changeProfileUpdate(
                                                        _vm.configureFields
                                                          .profileUpdatePhoneNumber,
                                                        "phoneNumber"
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.configureFields
                                                        .profileUpdatePhoneNumber,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.configureFields,
                                                        "profileUpdatePhoneNumber",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "configureFields.profileUpdatePhoneNumber"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.defaultProfileUpdateList,
                                                  function(value, index) {
                                                    return _c(
                                                      "md-option",
                                                      {
                                                        key: index,
                                                        attrs: { value: index }
                                                      },
                                                      [_vm._v(_vm._s(value))]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("hr", {
                                  staticClass: "request-hr m-left-5"
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-md-12" }, [
                                    _c("div", { staticClass: "col-md-4" }, [
                                      _c("h4", { staticClass: "mt-18" }, [
                                        _vm._v("Request Options")
                                      ])
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row m-left-5 mt-10" },
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass: "approval-response",
                                        model: {
                                          value: _vm.content.athenaEnabled,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.content,
                                              "athenaEnabled",
                                              $$v
                                            )
                                          },
                                          expression: "content.athenaEnabled"
                                        }
                                      },
                                      [_vm._v("Enable Athena for Long Wizard")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "form-content.athenaEnabled"
                                        ),
                                        expression:
                                          "errors.has('form-content.athenaEnabled')"
                                      }
                                    ],
                                    staticClass: "error m-left-5"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "form-content.athenaEnabled"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row m-left-5 mt-10" },
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass: "approval-response",
                                        model: {
                                          value: _vm.content.athenaEnabledQC,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.content,
                                              "athenaEnabledQC",
                                              $$v
                                            )
                                          },
                                          expression: "content.athenaEnabledQC"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Enable Athena for Quick Connect"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "form-content.athenaEnabledQC"
                                        ),
                                        expression:
                                          "errors.has('form-content.athenaEnabledQC')"
                                      }
                                    ],
                                    staticClass: "error m-left-5"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "form-content.athenaEnabledQC"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row m-left-5 mt-10" },
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass: "approval-response",
                                        model: {
                                          value:
                                            _vm.content.questionCoachEnabledLF,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.content,
                                              "questionCoachEnabledLF",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "content.questionCoachEnabledLF"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Enable Question Coach for Long Wizard"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "form-content.questionCoachEnabledLF"
                                        ),
                                        expression:
                                          "errors.has('form-content.questionCoachEnabledLF')"
                                      }
                                    ],
                                    staticClass: "error m-left-5"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "form-content.questionCoachEnabledLF"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row m-left-5 mt-10" },
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass: "approval-response",
                                        model: {
                                          value:
                                            _vm.content.questionCoachEnabled,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.content,
                                              "questionCoachEnabled",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "content.questionCoachEnabled"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Enable Question Coach for Quick Connect"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "form-content.questionCoachEnabled"
                                        ),
                                        expression:
                                          "errors.has('form-content.questionCoachEnabled')"
                                      }
                                    ],
                                    staticClass: "error m-left-5"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "form-content.questionCoachEnabled"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row m-left-5 mt-10" },
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass: "approval-response",
                                        model: {
                                          value: _vm.content.enableMagicWandLF,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.content,
                                              "enableMagicWandLF",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "content.enableMagicWandLF"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Enable the Magic Wand feature for the Long Wizard"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "form-content.enableMagicWandLF"
                                        ),
                                        expression:
                                          "errors.has('form-content.enableMagicWandLF')"
                                      }
                                    ],
                                    staticClass: "error m-left-5"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "form-content.enableMagicWandLF"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "row m-left-5 mt-10" },
                                  [
                                    _c(
                                      "md-checkbox",
                                      {
                                        staticClass: "approval-response",
                                        model: {
                                          value: _vm.content.magicWandEnabled,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.content,
                                              "magicWandEnabled",
                                              $$v
                                            )
                                          },
                                          expression: "content.magicWandEnabled"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Enable the Magic Wand feature for Quick Connect"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "form-content.magicWandEnabled"
                                        ),
                                        expression:
                                          "errors.has('form-content.magicWandEnabled')"
                                      }
                                    ],
                                    staticClass: "error m-left-5"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "form-content.magicWandEnabled"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised md-round md-accent m-left-5",
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v(_vm._s(_vm.requestSaveContentText))]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("CommunityContentSection", {
        attrs: {
          community_id: _vm.community_id,
          content: _vm.content,
          labelValidate: _vm.labelValidate
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box mt-10" },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    { attrs: { "md-alignment": "space-between" } },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "community-expand-button m-left-5" },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.expandchannel("Campaigns")
                                    }
                                  }
                                },
                                [_vm._v("Campaigns")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      _c("md-card-content", { staticClass: "card-content" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.opened.includes("Campaigns"),
                                expression: "opened.includes('Campaigns')"
                              }
                            ],
                            class: { opened: _vm.opened.includes("Campaigns") }
                          },
                          [
                            _c(
                              "form",
                              {
                                attrs: { "data-vv-scope": "campaignsform-2" },
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.saveCampaign("campaignsform-2")
                                  }
                                }
                              },
                              [
                                _vm._l(6, function(index) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "md-layout md-gutter md-field pt-0 mb-0 mlminus-15"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "md-layout-item md-size-60 m-left-6"
                                          },
                                          [
                                            _c(
                                              "md-field",
                                              {
                                                staticClass: "create-community"
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass: "card-header"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getBannerLabel(
                                                          index
                                                        )
                                                      ) + " Image URL "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("md-input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: false,
                                                        regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                                                      },
                                                      expression:
                                                        "{ required: false, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                                                    }
                                                  ],
                                                  attrs: {
                                                    name:
                                                      "banner" +
                                                      index +
                                                      "ImageUrl",
                                                    placeholder:
                                                      _vm.getBannerLabel(
                                                        index
                                                      ) + " Image URL"
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      _vm.campaign[
                                                        "banner" + index
                                                      ][
                                                        "imageUrl"
                                                      ] = _vm.sanitizeUrl(
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.campaign[
                                                        "banner" + index
                                                      ]["imageUrl"],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.campaign[
                                                          "banner" + index
                                                        ],
                                                        "imageUrl",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression:
                                                      "campaign['banner'+index]['imageUrl']"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "campaignsform-2.banner" +
                                                        index +
                                                        "ImageUrl"
                                                    ),
                                                    expression:
                                                      "errors.has(`campaignsform-2.banner${index}ImageUrl`)"
                                                  }
                                                ],
                                                staticClass: "error"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "campaignsform-2.banner" +
                                                        index +
                                                        "ImageUrl"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "md-layout-item md-size-40"
                                          },
                                          [
                                            _c(
                                              "md-field",
                                              {
                                                staticClass: "create-community"
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "card-header fs-12"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getBannerLabel(
                                                          index
                                                        )
                                                      ) + " destination URL"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("md-input", {
                                                  directives: [
                                                    {
                                                      name: "validate",
                                                      rawName: "v-validate",
                                                      value: {
                                                        required: false,
                                                        regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&%\$#_]*)?$/
                                                      },
                                                      expression:
                                                        "{ required: false, regex: /^http(s?)\\:\\/\\/[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z])*(:(0-9)*)*(\\/?)([a-zA-Z0-9\\-\\.\\?\\,\\'\\/\\\\\\+&%\\$#_]*)?$/ }"
                                                    }
                                                  ],
                                                  attrs: {
                                                    name:
                                                      "banner" +
                                                      index +
                                                      "DestinationUrl",
                                                    placeholder:
                                                      _vm.getBannerLabel(
                                                        index
                                                      ) + " destination URL"
                                                  },
                                                  on: {
                                                    input: function($event) {
                                                      _vm.campaign[
                                                        "banner" + index
                                                      ][
                                                        "destinationUrl"
                                                      ] = _vm.sanitizeUrl(
                                                        $event
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.campaign[
                                                        "banner" + index
                                                      ]["destinationUrl"],
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.campaign[
                                                          "banner" + index
                                                        ],
                                                        "destinationUrl",
                                                        typeof $$v === "string"
                                                          ? $$v.trim()
                                                          : $$v
                                                      )
                                                    },
                                                    expression:
                                                      "campaign['banner'+index]['destinationUrl']"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "campaignsform-2.banner" +
                                                        index +
                                                        "DestinationUrl"
                                                    ),
                                                    expression:
                                                      "errors.has(`campaignsform-2.banner${index}DestinationUrl`)"
                                                  }
                                                ],
                                                staticClass: "error"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.errors.first(
                                                      "campaignsform-2.banner" +
                                                        index +
                                                        "DestinationUrl"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                }),
                                _vm._v(" "),
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised md-round md-accent mt-20",
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v("Save")]
                                )
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box mt-10" },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    { attrs: { "md-alignment": "left" } },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "community-expand-button m-left-5" },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.expandchannel("template")
                                    }
                                  }
                                },
                                [_vm._v("Templates")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticClass: "small-icon picker-icon m-left-5",
                        attrs: { icon: "plus-circle" },
                        on: {
                          click: function($event) {
                            return _vm.addTemplate()
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      _c("md-card-content", { staticClass: "card-content" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.opened.includes("template"),
                                expression: "opened.includes('template')"
                              }
                            ],
                            class: { opened: _vm.opened.includes("") }
                          },
                          [
                            _c(
                              "form",
                              {
                                staticClass: "form-template",
                                attrs: { "data-vv-scope": "form-template" },
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.submitTemplates("form-template")
                                  }
                                }
                              },
                              [
                                _vm._l(_vm.selectTemp, function(temp, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: "template-" + index,
                                      staticClass: "row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "col-md-5" },
                                        [
                                          _c(
                                            "md-field",
                                            {
                                              staticClass:
                                                "m-left-5 md-has-value"
                                            },
                                            [
                                              _c(
                                                "label",
                                                { attrs: { for: "original" } },
                                                [_vm._v("Original")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-select",
                                                {
                                                  attrs: {
                                                    name: "original",
                                                    placeholder:
                                                      "Please select template"
                                                  },
                                                  on: {
                                                    "md-selected": function(
                                                      $event
                                                    ) {
                                                      return _vm.selectOriginal(
                                                        index,
                                                        temp.original
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: temp.original,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        temp,
                                                        "original",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "temp.original"
                                                  }
                                                },
                                                _vm._l(_vm.templates, function(
                                                  t
                                                ) {
                                                  return _c(
                                                    "md-option",
                                                    {
                                                      key: t.ref_id,
                                                      attrs: {
                                                        disabled: _vm.originalTemp.includes(
                                                          t.ref_id
                                                        ),
                                                        value: t.ref_id
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(t.name))]
                                                  )
                                                }),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-1 text-center" },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "mt-25 angle-left-img-sm",
                                            attrs: {
                                              src: require("../assets/arrow.png")
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-md-5" },
                                        [
                                          _c(
                                            "md-field",
                                            {
                                              staticClass:
                                                "m-left-5 md-has-value"
                                            },
                                            [
                                              _c(
                                                "label",
                                                { attrs: { for: "override" } },
                                                [_vm._v("Override")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-select",
                                                {
                                                  attrs: {
                                                    name: "override",
                                                    placeholder:
                                                      "Please select template"
                                                  },
                                                  model: {
                                                    value: temp.override,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        temp,
                                                        "override",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "temp.override"
                                                  }
                                                },
                                                _vm._l(_vm.templates, function(
                                                  t
                                                ) {
                                                  return _c(
                                                    "md-option",
                                                    {
                                                      key: t.ref_id,
                                                      attrs: { value: t.ref_id }
                                                    },
                                                    [_vm._v(_vm._s(t.name))]
                                                  )
                                                }),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "col-md-1" }, [
                                        _c("div", { staticClass: "mt-25" }, [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "text-primary",
                                              attrs: {
                                                href: "javascript:void(0)"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.deleteRow(index)
                                                }
                                              }
                                            },
                                            [_vm._v("Delete")]
                                          )
                                        ])
                                      ])
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised md-round md-accent m-left-5",
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v(_vm._s(_vm.saveContentText))]
                                )
                              ],
                              2
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "box mt-10" },
        [
          _c(
            "md-card",
            [
              _c(
                "md-card-expand",
                [
                  _c(
                    "md-card-actions",
                    { attrs: { "md-alignment": "space-between" } },
                    [
                      _c(
                        "md-card-expand-trigger",
                        [
                          _c(
                            "md-button",
                            { staticClass: "community-expand-button m-left-5" },
                            [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.expandchannel("email")
                                    }
                                  }
                                },
                                [_vm._v("Email")]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "md-card-expand-content",
                    [
                      _c("md-card-content", { staticClass: "card-content" }, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.opened.includes("email"),
                                expression: "opened.includes('email')"
                              }
                            ],
                            class: { opened: _vm.opened.includes("email") }
                          },
                          [
                            _c(
                              "form",
                              {
                                attrs: { "data-vv-scope": "form-email" },
                                on: {
                                  submit: function($event) {
                                    $event.preventDefault()
                                    return _vm.submitEmails("form-email")
                                  }
                                }
                              },
                              [
                                _c(
                                  "md-field",
                                  { staticClass: "m-left-5" },
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "original" } },
                                      [_vm._v("Email Template")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "md-select",
                                      {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          name: "selectTemplate",
                                          placeholder: "Please select template"
                                        },
                                        model: {
                                          value: _vm.selectTemplate,
                                          callback: function($$v) {
                                            _vm.selectTemplate = $$v
                                          },
                                          expression: "selectTemplate"
                                        }
                                      },
                                      _vm._l(_vm.templates, function(t) {
                                        return _c(
                                          "md-option",
                                          {
                                            key: t.ref_id,
                                            attrs: { value: t.ref_id }
                                          },
                                          [_vm._v(_vm._s(t.name))]
                                        )
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "form-email.selectTemplate"
                                        ),
                                        expression:
                                          "errors.has('form-email.selectTemplate')"
                                      }
                                    ],
                                    staticClass: "error m-left-5"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "form-email.selectTemplate"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-field",
                                  [
                                    _c("label", [_vm._v("Email Address")]),
                                    _vm._v(" "),
                                    _c("md-textarea", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        }
                                      ],
                                      attrs: {
                                        name: "emailAddresses",
                                        placeholder: "Enter email addresses"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.emailAddresses = _vm.sanitizeInput(
                                            $event
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.emailAddresses,
                                        callback: function($$v) {
                                          _vm.emailAddresses = $$v
                                        },
                                        expression: "emailAddresses"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "md-helper-text" },
                                      [
                                        _vm._v(
                                          "Multiple email address must be comma(,) separated"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "form-email.emailAddresses"
                                        ),
                                        expression:
                                          "errors.has('form-email.emailAddresses')"
                                      }
                                    ],
                                    staticClass: "error m-left-5"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "form-email.emailAddresses"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised md-round md-accent mt-20",
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v("Send")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-10" },
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "left" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c(
                        "md-button",
                        { staticClass: "community-expand-button m-left-5" },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.expandchannel("advisors")
                                }
                              }
                            },
                            [_vm._v("Advisors")]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "m-left-10" },
                    [
                      _c(
                        "member-picker",
                        {
                          attrs: {
                            community: _vm.$route.params.community_id,
                            section: "advisers"
                          },
                          on: { chosen: _vm.addAdvisors }
                        },
                        [_vm._v("Choose advisor...")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-card-expand-content",
                [
                  _c(
                    "md-card-content",
                    { staticClass: "card-content" },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "empty-admin-state m-left-5 m-remove",
                          staticStyle: { fontSize: "14px", color: "grey" }
                        },
                        [
                          _c("small", [
                            _vm._v(
                              "Note : Remove button will not display for partner communities advisors."
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("search-bar", {
                        attrs: {
                          placeholder: "Search advisors...",
                          name: "searchAdvisor"
                        },
                        on: {
                          search: _vm.searchAdvisorsBtn,
                          clear: function($event) {
                            return _vm.resetSearch("advisors")
                          }
                        },
                        model: {
                          value: _vm.searchAdvisors,
                          callback: function($$v) {
                            _vm.searchAdvisors = $$v
                          },
                          expression: "searchAdvisors"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "md-table",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.opened.includes("advisors"),
                              expression: "opened.includes('advisors')"
                            }
                          ],
                          class: [
                            "advisor-table",
                            { opened: _vm.opened.includes("advisors") }
                          ]
                        },
                        [
                          _vm.advisorsList
                            ? _c(
                                "md-table-row",
                                [
                                  _c(
                                    "md-table-head",
                                    { staticClass: "card-header" },
                                    [
                                      _vm._v("Name\n\t\t\t\t\t\t\t\t\t\t "),
                                      _vm.currentAdvisorSortDisplayName ===
                                      "desc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-down" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortAdvisor(
                                                  "asc",
                                                  "displayName"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentAdvisorSortDisplayName ===
                                      "asc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-up" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortAdvisor(
                                                  "desc",
                                                  "displayName"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    { staticClass: "card-header" },
                                    [
                                      _vm._v("Email\n\t\t\t\t\t\t\t\t\t\t\t "),
                                      _vm.currentAdvisorSortEmail === "desc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-down" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortAdvisor(
                                                  "asc",
                                                  "emails"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentAdvisorSortEmail === "asc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-up" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortAdvisor(
                                                  "desc",
                                                  "emails"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    { staticClass: "card-header" },
                                    [
                                      _vm._v(
                                        "Last Request Rec'd\n\t\t\t\t\t\t\t\t\t\t\t "
                                      ),
                                      _vm.currentAdvisorSortRequest === "desc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-down" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortAdvisor(
                                                  "asc",
                                                  "requestReceived.lastRequestReceived"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentAdvisorSortRequest === "asc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-up" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortAdvisor(
                                                  "desc",
                                                  "requestReceived.lastRequestReceived"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    { staticClass: "card-header" },
                                    [
                                      _vm._v(
                                        "Last Response\n\t\t\t\t\t\t\t\t\t\t\t "
                                      ),
                                      _vm.currentAdvisorSortResponse === "desc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-down" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortAdvisor(
                                                  "asc",
                                                  "response.lastResponse"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentAdvisorSortResponse === "asc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-up" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortAdvisor(
                                                  "desc",
                                                  "response.lastResponse"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    { staticClass: "card-header" },
                                    [
                                      _vm._v(
                                        "Last Feedback\n\t\t\t\t\t\t\t\t\t\t "
                                      ),
                                      _vm.currentAdvisorSortLastFeedback ===
                                      "desc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-down" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortAdvisor(
                                                  "asc",
                                                  "lastFeedback"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentAdvisorSortLastFeedback ===
                                      "asc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-up" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortAdvisor(
                                                  "desc",
                                                  "lastFeedback"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    { staticClass: "card-header" },
                                    [_vm._v("Actions")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.advisorsList, function(advisor, index) {
                            return [
                              _vm.searchAdvisors !== "" &&
                              index < _vm.showSearchAdvisor
                                ? _c(
                                    "admin-list",
                                    {
                                      key: "advisor_" + advisor._id + index,
                                      attrs: {
                                        member: advisor,
                                        dataType: "advisor"
                                      },
                                      on: { remove: _vm.removeAdvisor }
                                    },
                                    [_vm._v("Advisor goes here...")]
                                  )
                                : index < _vm.showAdvisors
                                ? _c(
                                    "admin-list",
                                    {
                                      key: "advisor_" + advisor._id + index,
                                      attrs: {
                                        member: advisor,
                                        dataType: "advisor"
                                      },
                                      on: { remove: _vm.removeAdvisor }
                                    },
                                    [_vm._v("Advisor goes here...")]
                                  )
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.opened.includes("advisors")
                        ? _c(
                            "div",
                            { staticClass: "w-100 text-center mt-20" },
                            [
                              _vm.showAdvisorsLoadMore()
                                ? _c(
                                    "md-button",
                                    {
                                      staticClass:
                                        "md-mini btnplain capitalize card-header",
                                      on: {
                                        click: function($event) {
                                          return _vm.loadAdvisorsWithApi(
                                            _vm.searchAdvisors
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Load More")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-10" },
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "left" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c(
                        "md-button",
                        { staticClass: "community-expand-button m-left-5" },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.expandchannel("members")
                                }
                              }
                            },
                            [_vm._v("Members")]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "m-left-10" },
                    [
                      _c(
                        "member-picker",
                        {
                          attrs: {
                            section: "members",
                            community: _vm.$route.params.community_id
                          },
                          on: { chosen: _vm.addMembers }
                        },
                        [_vm._v("Choose member...")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-card-expand-content",
                [
                  _c(
                    "md-card-content",
                    { staticClass: "card-content" },
                    [
                      _c("search-bar", {
                        attrs: {
                          placeholder: "Search members...",
                          name: "searchMember"
                        },
                        on: {
                          search: _vm.searchMemberBtn,
                          clear: function($event) {
                            return _vm.resetSearch("members")
                          }
                        },
                        model: {
                          value: _vm.searchMembers,
                          callback: function($$v) {
                            _vm.searchMembers = $$v
                          },
                          expression: "searchMembers"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "md-table",
                        {
                          class: [
                            "member-table",
                            { opened: _vm.opened.includes("members") }
                          ]
                        },
                        [
                          _vm.membersList
                            ? _c(
                                "md-table-row",
                                [
                                  _c(
                                    "md-table-head",
                                    { staticClass: "card-header" },
                                    [
                                      _vm._v("Name\n\t\t\t\t\t\t\t\t\t "),
                                      _vm.currentMemberSortDisplayName ===
                                      "desc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-down" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortMember(
                                                  "asc",
                                                  "displayName"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentMemberSortDisplayName === "asc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-up" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortMember(
                                                  "desc",
                                                  "displayName"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    { staticClass: "card-header" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\tEmail\n\t\t\t\t\t\t\t\t\t\t "
                                      ),
                                      _vm.currentMemberSortEmail === "desc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-down" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortMember(
                                                  "asc",
                                                  "emails"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentMemberSortEmail === "asc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-up" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortMember(
                                                  "desc",
                                                  "emails"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    { staticClass: "card-header" },
                                    [
                                      _vm._v(
                                        "Last Request Rec'd\n\t\t\t\t\t\t\t\t\t\t "
                                      ),
                                      _vm.currentMemberSortRequest === "desc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-down" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortMember(
                                                  "asc",
                                                  "requestReceived.lastRequestReceived"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentMemberSortRequest === "asc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-up" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortMember(
                                                  "desc",
                                                  "requestReceived.lastRequestReceived"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    { staticClass: "card-header" },
                                    [
                                      _vm._v(
                                        "Last Response\n\t\t\t\t\t\t\t\t\t\t "
                                      ),
                                      _vm.currentMemberSortResponse === "desc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-down" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortMember(
                                                  "asc",
                                                  "response.lastResponse"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentMemberSortResponse === "asc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-up" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortMember(
                                                  "desc",
                                                  "response.lastResponse"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    { staticClass: "card-header" },
                                    [
                                      _vm._v(
                                        "Last Feedback\n\t\t\t\t\t\t\t\t\t "
                                      ),
                                      _vm.currentMemberSortLastFeedback ===
                                      "desc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-down" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortMember(
                                                  "asc",
                                                  "lastFeedback"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentMemberSortLastFeedback ===
                                      "asc"
                                        ? _c("font-awesome-icon", {
                                            staticClass:
                                              "selector font-24 float-right",
                                            attrs: { icon: "caret-up" },
                                            on: {
                                              click: function($event) {
                                                return _vm.sortMember(
                                                  "desc",
                                                  "lastFeedback"
                                                )
                                              }
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "md-table-head",
                                    { staticClass: "card-header" },
                                    [_vm._v("Status")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.membersList, function(member, index) {
                            return _vm.opened.includes("members")
                              ? [
                                  _vm.searchMembers !== "" &&
                                  index < _vm.showSearchMember
                                    ? _c(
                                        "member",
                                        {
                                          key: "member_" + member._id + index,
                                          attrs: {
                                            member: member,
                                            section: "communityMembers"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Member goes here...\n\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    : index < _vm.showMember
                                    ? _c(
                                        "member",
                                        {
                                          key: "member_" + member._id + index,
                                          attrs: {
                                            member: member,
                                            section: "communityMembers"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Member goes here...\n\t\t\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : _vm._e()
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.opened.includes("members")
                        ? _c(
                            "div",
                            { staticClass: "w-100 text-center mt-20" },
                            [
                              _vm.showMembersLoadMore()
                                ? _c(
                                    "md-button",
                                    {
                                      staticClass:
                                        "md-mini btnplain capitalize card-header",
                                      on: {
                                        click: function($event) {
                                          return _vm.loadMembersWithApi(
                                            _vm.searchMembers
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Load More")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "box mt-10" },
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "left" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c(
                        "md-button",
                        { staticClass: "community-expand-button m-left-5" },
                        [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.expandchannel("4")
                                }
                              }
                            },
                            [_vm._v("Channels")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-card-expand-content",
                [
                  _vm.opened.includes("4")
                    ? _c("md-card-content", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "m-left-5" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout md-gutter md-field pt-0 mb-0"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout-item md-size-60 m-left-6"
                                },
                                [
                                  _c("h4", { staticClass: "m-left-5" }, [
                                    _vm._v("Add Ask")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "m-left-5 m-top-20",
                                        {
                                          picker: _vm.$lodash.has(
                                            _vm.createdByMember,
                                            "_id"
                                          )
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.createdByMember.displayName
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t\t\t"
                                      ),
                                      _c(
                                        "member-picker",
                                        {
                                          attrs: {
                                            iconName: "Member",
                                            section: "addAsk",
                                            community:
                                              _vm.$route.params.community_id
                                          },
                                          on: { chosen: _vm.addSeeker }
                                        },
                                        [_vm._v("Choose advisor...")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  this.isHasMember
                                    ? _c("p", { staticClass: "error" }, [
                                        _vm._v("Please select member")
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "md-layout-item md-size-40" },
                                [
                                  _c(
                                    "md-field",
                                    {
                                      staticClass: "create-community m-left-5"
                                    },
                                    [
                                      _c(
                                        "label",
                                        { staticClass: "card-header" },
                                        [_vm._v("Community Ask Friendly Name")]
                                      ),
                                      _vm._v(" "),
                                      _c("md-input", {
                                        attrs: {
                                          name: "community_ask_friendly_name",
                                          placeholder:
                                            "Community Ask Friendly Name"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.friendlyNames.communityAsk = _vm.sanitizeInput(
                                              $event
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.friendlyNames.communityAsk,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.friendlyNames,
                                              "communityAsk",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "friendlyNames.communityAsk"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "form",
                            {
                              staticClass: "custom-textarea",
                              attrs: { "data-vv-scope": "form-1" },
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.sendCreate("form-1")
                                }
                              }
                            },
                            [
                              _c(
                                "md-field",
                                { staticClass: "create-ask m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Subject")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      name: "subject",
                                      placeholder: "Request summary...",
                                      "md-autogrow": ""
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.askSubject = _vm.sanitizeInput(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.askSubject,
                                      callback: function($$v) {
                                        _vm.askSubject =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "askSubject"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has("form-1.subject"),
                                      expression: "errors.has('form-1.subject')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.errors.first("form-1.subject"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-field",
                                { staticClass: "create-ask m-left-5" },
                                [
                                  _c("label", { staticClass: "card-header" }, [
                                    _vm._v("Description")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      name: "description",
                                      placeholder: "Describe the request...",
                                      "md-autogrow": ""
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.askText = _vm.sanitizeInput($event)
                                      }
                                    },
                                    model: {
                                      value: _vm.askText,
                                      callback: function($$v) {
                                        _vm.askText =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "askText"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-1.description"
                                      ),
                                      expression:
                                        "errors.has('form-1.description')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first("form-1.description")
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-raised md-round md-accent",
                                  attrs: { type: "submit" }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tSubmit\n\t\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("hr", {
                          staticClass: "dark-border m-left-5 mt-40 mb-40"
                        }),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            staticClass: "form-channel-2",
                            attrs: { "data-vv-scope": "form-channel-2" },
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.updateChannel("form-channel-2")
                              }
                            }
                          },
                          [
                            _c("div", [
                              _c("h4", { staticClass: "m-remove m-left-5" }, [
                                _c("p", { staticClass: "empty-admin-state" }, [
                                  _vm._v("Webform")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout md-gutter md-field pt-0 mb-0 mlminus-15"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-size-60 m-left-6"
                                    },
                                    [
                                      _c(
                                        "md-field",
                                        {
                                          staticClass:
                                            "create-community m-left-5"
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "card-header" },
                                            [
                                              _vm._v(
                                                "Request Page - Single Page"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("md-input", {
                                            staticClass: "not-allowed",
                                            attrs: {
                                              name: "request page",
                                              readonly: "",
                                              placeholder: "Request Page URL"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.content.requestPageURL = _vm.sanitizeUrl(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.content.requestPageURL,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.content,
                                                  "requestPageURL",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "content.requestPageURL"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "md-layout-item md-size-40"
                                    },
                                    [
                                      _c(
                                        "md-field",
                                        {
                                          staticClass:
                                            "create-community m-left-5"
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "card-header" },
                                            [
                                              _vm._v(
                                                "Request Page - Single Page Friendly Name"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("md-input", {
                                            attrs: {
                                              name:
                                                "request_page_friendly_name",
                                              placeholder:
                                                "Request Page Friendly Name"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.friendlyNames.requestForm = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.friendlyNames.requestForm,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.friendlyNames,
                                                  "requestForm",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "friendlyNames.requestForm"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("form-content.request page")
                                ? _c("p", { staticClass: "error m-left-5" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.errors.first(
                                          "form-content.request page"
                                        )
                                      )
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout md-gutter md-field pt-0 mb-0 mlminus-15"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-size-60 m-left-6"
                                    },
                                    [
                                      _c(
                                        "md-field",
                                        {
                                          staticClass:
                                            "create-community m-left-5"
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "card-header" },
                                            [_vm._v("Request Page - Long")]
                                          ),
                                          _vm._v(" "),
                                          _c("md-input", {
                                            staticClass: "not-allowed",
                                            attrs: {
                                              name: "request page",
                                              readonly: "",
                                              placeholder: "Request Page - Long"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.content.requestV3URL = _vm.sanitizeUrl(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.content.requestV3URL,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.content,
                                                  "requestV3URL",
                                                  $$v
                                                )
                                              },
                                              expression: "content.requestV3URL"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "md-layout-item md-size-40"
                                    },
                                    [
                                      _c(
                                        "md-field",
                                        {
                                          staticClass:
                                            "create-community m-left-5"
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "card-header" },
                                            [
                                              _vm._v(
                                                "Request Page - Long Friendly Name"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("md-input", {
                                            attrs: {
                                              name:
                                                "request_page_friendly_name",
                                              placeholder:
                                                "Request Page Long Friendly Name"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.friendlyNames.requestForm1 = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.friendlyNames.requestForm1,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.friendlyNames,
                                                  "requestForm1",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "friendlyNames.requestForm1"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "form-content.requestV2URL"
                                      ),
                                      expression:
                                        "errors.has('form-content.requestV2URL')"
                                    }
                                  ],
                                  staticClass: "error m-left-5"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "form-content.requestV2URL"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("hr", {
                              staticClass: "dark-border m-left-5 mt-40 mb-40"
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout md-gutter md-field pt-0 mb-0 mlminus-15"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "md-layout-item md-size-60 m-left-6"
                                  },
                                  [
                                    _c(
                                      "md-card-actions",
                                      {
                                        staticClass: "ptop0",
                                        attrs: { "md-alignment": "left" }
                                      },
                                      [
                                        _c("h4", [_vm._v("Emails")]),
                                        _vm._v(" "),
                                        _c(
                                          "md-card-actions",
                                          { attrs: { "md-alignment": "left" } },
                                          [
                                            _c("font-awesome-icon", {
                                              staticClass:
                                                "small-icon picker-icon m-left-5",
                                              attrs: { icon: "plus-circle" },
                                              on: {
                                                click: function($event) {
                                                  _vm.showDialog = true
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "md-dialog",
                                      {
                                        attrs: { "md-active": _vm.showDialog },
                                        on: {
                                          "update:mdActive": function($event) {
                                            _vm.showDialog = $event
                                          },
                                          "update:md-active": function($event) {
                                            _vm.showDialog = $event
                                          }
                                        }
                                      },
                                      [
                                        _c("md-dialog-title", [
                                          _vm._v("Authorize with")
                                        ]),
                                        _vm._v(" "),
                                        _c("md-dialog-actions", [
                                          _c("img", {
                                            staticClass: "authorize-channel",
                                            attrs: {
                                              src: require("../assets/gmail.png")
                                            },
                                            on: { click: _vm.getGmailAuthURL }
                                          }),
                                          _vm._v(" "),
                                          _c("img", {
                                            staticClass: "authorize-channel",
                                            attrs: {
                                              src: require("../assets/outlook.png")
                                            },
                                            on: { click: _vm.getOutlookAuthURL }
                                          })
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "m-left-8" }, [
                                      _vm.isValidating
                                        ? _c(
                                            "form",
                                            {
                                              attrs: {
                                                "data-vv-scope": "form-3"
                                              },
                                              on: {
                                                submit: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.confirmCode(
                                                    "form-3"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "md-field",
                                                {
                                                  staticClass:
                                                    "md-focused md-field-margin"
                                                },
                                                [
                                                  _c("label", [
                                                    _vm._v(
                                                      "Enter Validation Code:"
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("md-input", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    attrs: { name: "code" },
                                                    on: {
                                                      input: function($event) {
                                                        _vm.validationCode = _vm.sanitizeInput(
                                                          $event
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value: _vm.validationCode,
                                                      callback: function($$v) {
                                                        _vm.validationCode = $$v
                                                      },
                                                      expression:
                                                        "validationCode"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: _vm.errors.has(
                                                        "form-3.code"
                                                      ),
                                                      expression:
                                                        "errors.has('form-3.code')"
                                                    }
                                                  ],
                                                  staticClass: "error"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.errors.first(
                                                        "form-3.code"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "md-button",
                                                {
                                                  staticClass:
                                                    "md-raised md-round md-accent md-left-marign-remove",
                                                  attrs: { type: "submit" }
                                                },
                                                [_vm._v("Confirm Code")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "channel-list m-left-5" },
                                      _vm._l(_vm.community.channels, function(
                                        channel,
                                        index
                                      ) {
                                        return _c(
                                          "ul",
                                          {
                                            key: "channel-" + index,
                                            staticClass: "list-inline"
                                          },
                                          [
                                            _c(
                                              "li",
                                              { key: "icon" + index },
                                              [
                                                channel.authorizeMode ===
                                                "outlook"
                                                  ? [
                                                      channel.imageURL
                                                        ? _c("img", {
                                                            staticClass:
                                                              "user-image",
                                                            attrs: {
                                                              src:
                                                                channel.imageURL
                                                            }
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      !channel.imageURL
                                                        ? _c("img", {
                                                            staticClass:
                                                              "user-image",
                                                            attrs: {
                                                              src: require("../assets/person.png")
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  : _c(
                                                      "md-avatar",
                                                      {
                                                        staticClass: "md-medium"
                                                      },
                                                      [
                                                        channel.imageURL
                                                          ? _c("img", {
                                                              staticClass:
                                                                "user-image",
                                                              attrs: {
                                                                src:
                                                                  channel.imageURL
                                                              }
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        !channel.imageURL
                                                          ? _c("img", {
                                                              staticClass:
                                                                "user-image",
                                                              attrs: {
                                                                src: require("../assets/person.png")
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              { key: "email-" + index },
                                              [
                                                _vm._v(
                                                  _vm._s(channel.memberEmail)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              {
                                                key: "channel-config-" + index
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  [
                                                    _c("font-awesome-icon", {
                                                      staticClass: "small-icon",
                                                      attrs: {
                                                        icon: "pencil-alt"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.expandContent(
                                                            channel._id
                                                          )
                                                        }
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              {
                                                key:
                                                  "channel-config-" +
                                                  index +
                                                  "-delete"
                                              },
                                              [
                                                _c("md-dialog-confirm", {
                                                  attrs: {
                                                    "md-active":
                                                      _vm.activeChannel,
                                                    "md-title":
                                                      channel.memberEmail +
                                                      " Channel",
                                                    "md-content":
                                                      "<strong>Are you sure you want to delete this channel? </strong>"
                                                  },
                                                  on: {
                                                    "update:mdActive": function(
                                                      $event
                                                    ) {
                                                      _vm.activeChannel = $event
                                                    },
                                                    "update:md-active": function(
                                                      $event
                                                    ) {
                                                      _vm.activeChannel = $event
                                                    },
                                                    "md-confirm": function(
                                                      $event
                                                    ) {
                                                      return _vm.deleteChannel(
                                                        channel._id
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href:
                                                          "javascript:void(0)"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.activeChannel = true
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa fa-trash",
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ])
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.opened.includes(
                                                      channel._id
                                                    ),
                                                    expression:
                                                      "opened.includes(channel._id)"
                                                  }
                                                ],
                                                key: "channel-data-" + index,
                                                staticClass:
                                                  "channel-configuration"
                                              },
                                              [
                                                _c("p", [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "display-link",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.getMail(
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Get Mail")]
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  [
                                                    !channel.lastSyncDate
                                                      ? _c(
                                                          "md-checkbox",
                                                          {
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.syncChannel(
                                                                  index
                                                                )
                                                              }
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.community
                                                                  .channels[
                                                                  index
                                                                ].syncEnabled,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.community
                                                                    .channels[
                                                                    index
                                                                  ],
                                                                  "syncEnabled",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "community.channels[index].syncEnabled"
                                                            }
                                                          },
                                                          [_vm._v("Sync")]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    channel.lastSyncDate
                                                      ? _c(
                                                          "md-checkbox",
                                                          {
                                                            attrs: {
                                                              checked:
                                                                _vm.community
                                                                  .channels[
                                                                  index
                                                                ].syncEnabled
                                                            },
                                                            on: {
                                                              change: function(
                                                                $event
                                                              ) {
                                                                return _vm.syncChannel(
                                                                  index
                                                                )
                                                              }
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.community
                                                                  .channels[
                                                                  index
                                                                ].syncEnabled,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.community
                                                                    .channels[
                                                                    index
                                                                  ],
                                                                  "syncEnabled",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "community.channels[index].syncEnabled"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                "Sync (last synced: " +
                                                                  _vm
                                                                    .$moment(
                                                                      channel.lastSyncDate
                                                                    )
                                                                    .format(
                                                                      "YYYY-MM-DD hh:mm"
                                                                    ) +
                                                                  ")"
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "md-layout-item md-size-40" },
                                  [
                                    _c(
                                      "md-field",
                                      {
                                        staticClass: "create-community m-left-5"
                                      },
                                      [
                                        _c(
                                          "label",
                                          { staticClass: "card-header" },
                                          [_vm._v("Email Friendly Name")]
                                        ),
                                        _vm._v(" "),
                                        _c("md-input", {
                                          attrs: {
                                            name: "email_friendly_name",
                                            placeholder: "Email Friendly Name"
                                          },
                                          on: {
                                            input: function($event) {
                                              _vm.friendlyNames.email = _vm.sanitizeInput(
                                                $event
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.friendlyNames.email,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.friendlyNames,
                                                "email",
                                                $$v
                                              )
                                            },
                                            expression: "friendlyNames.email"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("hr", {
                              staticClass: "dark-border m-left-5 mt-40 mb-40"
                            }),
                            _vm._v(" "),
                            _c("div", [
                              _c("h4", { staticClass: "m-remove m-left-5" }, [
                                _c("p", { staticClass: "empty-admin-state" }, [
                                  _vm._v("Bot")
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout md-gutter md-field pt-0 mb-0 mlminus-15"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-size-60 m-left-6"
                                    },
                                    [
                                      _c(
                                        "md-field",
                                        {
                                          staticClass:
                                            "create-community m-left-5"
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "card-header" },
                                            [_vm._v("Chatbot Page URL")]
                                          ),
                                          _vm._v(" "),
                                          _c("md-input", {
                                            staticClass: "not-allowed",
                                            attrs: {
                                              value: _vm.chatbotPageUrl,
                                              readonly: "",
                                              placeholder: "Chatbot Page URL"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.chatbotPageUrl = _vm.sanitizeUrl(
                                                  $event
                                                )
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "md-layout-item md-size-40"
                                    },
                                    [
                                      _c(
                                        "md-field",
                                        {
                                          staticClass:
                                            "create-community m-left-5"
                                        },
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "card-header" },
                                            [_vm._v("Chatbot Friendly Name")]
                                          ),
                                          _vm._v(" "),
                                          _c("md-input", {
                                            attrs: {
                                              name: "chatbot_friendly_name",
                                              placeholder:
                                                "Chatbot Friendly Name"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.friendlyNames.chatbot = _vm.sanitizeInput(
                                                  $event
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.friendlyNames.chatbot,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.friendlyNames,
                                                  "chatbot",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "friendlyNames.chatbot"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "md-button",
                              {
                                staticClass:
                                  "mt-20 md-raised md-round md-accent",
                                attrs: { type: "submit" }
                              },
                              [_vm._v(_vm._s(_vm.saveChannelText))]
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-card",
        { staticClass: "mt-10 mb-10" },
        [
          _c(
            "md-card-expand",
            [
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "left" } },
                [
                  _c(
                    "md-card-expand-trigger",
                    [
                      _c(
                        "md-button",
                        { staticClass: "community-expand-button m-left-5" },
                        [_c("div", [_vm._v("Data Uploads")])]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-card-expand-content",
                [
                  _c(
                    "md-card-content",
                    { staticClass: "card-content" },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "https://storage.googleapis.com/protopia/app/web/sample-member-upload.csv",
                                title: "Download sample file",
                                download: ""
                              }
                            },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-raised md-accent md-black-color capitalize"
                                },
                                [_vm._v("Download Member Template")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "md-raised md-accent md-black-color capitalize",
                              on: {
                                click: function($event) {
                                  return _vm.$refs.uploadMembersFile.click()
                                }
                              }
                            },
                            [_vm._v("Upload Members CSV File")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            ref: "uploadMembersFile",
                            staticStyle: { display: "none" },
                            attrs: {
                              type: "file",
                              accept: ".csv",
                              id: "upload-members"
                            },
                            on: { change: _vm.uploadMembersNew }
                          }),
                          _vm._v(" "),
                          _vm.isDownloadBtnDisabled
                            ? _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-raised md-accent md-black-color capitalize",
                                  attrs: { disabled: _vm.isDownloadBtnDisabled }
                                },
                                [
                                  _vm._v("Download Resources "),
                                  _c("i", {
                                    staticClass: "fa fa-spinner",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              )
                            : _c(
                                "md-button",
                                {
                                  staticClass:
                                    "md-raised resource-btn md-black-color capitalize",
                                  attrs: {
                                    disabled: _vm.isDownloadBtnDisabled
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.downloadResources()
                                    }
                                  }
                                },
                                [_vm._v("Download Resources")]
                              ),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "md-raised resource-btn md-black-color capitalize",
                              staticStyle: { margin: "6px 8px" },
                              on: {
                                click: function($event) {
                                  return _vm.$refs.uploadResourcesFile.click()
                                }
                              }
                            },
                            [_vm._v("Upload Resources CSV File")]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            ref: "uploadResourcesFile",
                            staticStyle: { display: "none" },
                            attrs: {
                              type: "file",
                              accept: ".csv",
                              id: "upload-resources"
                            },
                            on: { change: _vm.uploadResourcesNew }
                          }),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "md-raised md-accent md-black-color capitalize",
                              attrs: {
                                disabled: _vm.isOpportunityTemplateDownloading
                              },
                              on: {
                                click: function($event) {
                                  return _vm.downloadOpportunitiesTemplate()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\tDownload Opportunities Template\n\t\t\t\t\t\t\t\t"
                              ),
                              _vm.isOpportunityTemplateDownloading
                                ? _c("i", {
                                    staticClass: "fa fa-spinner fa-spin",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "md-raised md-accent md-black-color capitalize",
                              attrs: { disabled: _vm.isOpportunityUploading },
                              on: {
                                click: function($event) {
                                  return _vm.$refs.uploadOpportunitiesFile.click()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\tUpload Opportunities CSV File\n\t\t\t\t\t\t\t\t"
                              ),
                              _vm.isOpportunityUploading
                                ? _c("i", {
                                    staticClass: "fa fa-spinner fa-spin",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            ref: "uploadOpportunitiesFile",
                            staticStyle: { display: "none" },
                            attrs: {
                              type: "file",
                              accept: ".csv",
                              id: "upload-opportunities"
                            },
                            on: { change: _vm.uploadOpportunitiesNew }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "upload-log-section",
                        {
                          attrs: {
                            title: "Member Uploads",
                            open: _vm.openUploadSection === "members"
                          },
                          on: {
                            toggle: function($event) {
                              return _vm.toggleUploadSection("members")
                            }
                          }
                        },
                        [
                          _c("recent-uploads", {
                            attrs: { community_id: _vm.community._id }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "upload-log-section",
                        {
                          attrs: {
                            title: "Resource Uploads",
                            open: _vm.openUploadSection === "resources"
                          },
                          on: {
                            toggle: function($event) {
                              return _vm.toggleUploadSection("resources")
                            }
                          }
                        },
                        [
                          _c("recent-resource-uploads", {
                            attrs: { community_id: _vm.community._id }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "upload-log-section",
                        {
                          attrs: {
                            title: "Opportunity Uploads",
                            open: _vm.openUploadSection === "opportunities"
                          },
                          on: {
                            toggle: function($event) {
                              return _vm.toggleUploadSection("opportunities")
                            }
                          }
                        },
                        [
                          _vm.opportunityUploads.length === 0
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#888",
                                    padding: "8px 4px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\tNo opportunity files have been uploaded yet.\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.opportunityUploads, function(upload) {
                            return _c(
                              "div",
                              {
                                key: upload._id,
                                staticClass: "email",
                                staticStyle: { margin: "5px", padding: "5px" }
                              },
                              [
                                _c(
                                  "b",
                                  {
                                    staticStyle: {
                                      color: "purple",
                                      "font-size": "16px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "File: " +
                                        _vm._s(
                                          upload.fileName || "Unknown file"
                                        )
                                    )
                                  ]
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("b", [_vm._v("On:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      new Date(upload.when).toLocaleDateString()
                                    ) +
                                    " " +
                                    _vm._s(
                                      new Date(upload.when).toLocaleTimeString()
                                    ) +
                                    ",\n\t\t\t\t\t\t\t\t"
                                ),
                                _c("b", [_vm._v("Created:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(upload.created) +
                                    ",\n\t\t\t\t\t\t\t\t"
                                ),
                                _c("b", [_vm._v("Duplicates:")]),
                                _vm._v(
                                  " " +
                                    _vm._s(upload.duplicates) +
                                    ",\n\t\t\t\t\t\t\t\t"
                                ),
                                _c("b", [_vm._v("Failed:")]),
                                _vm._v(" " + _vm._s(upload.failedCount)),
                                _c("br"),
                                _vm._v(" "),
                                upload.failed.length
                                  ? _c(
                                      "button",
                                      {
                                        on: {
                                          click: function($event) {
                                            return _vm.toggleOpportunityFailed(
                                              upload._id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.isOpportunityFailedVisible(
                                                upload._id
                                              )
                                                ? "Close Failed"
                                                : "Show Failed"
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isOpportunityFailedVisible(upload._id)
                                  ? _c(
                                      "div",
                                      { staticStyle: { "margin-top": "8px" } },
                                      _vm._l(upload.failed, function(err, ei) {
                                        return _c(
                                          "div",
                                          {
                                            key:
                                              "opp-upload-" +
                                              upload._id +
                                              "-err-" +
                                              ei,
                                            staticStyle: { padding: "2px 0" }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t-- Row "
                                            ),
                                            _c("b", [_vm._v(_vm._s(err.row))]),
                                            _vm._v(": "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { color: "#c00" }
                                              },
                                              [_vm._v(_vm._s(err.error))]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9667e92e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9667e92e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Community.vue
// module id = null
// module chunks = 